import elementDrawing from "./elementDrawing";
import poseDetect from "./poseDetect";
import audioPlay from "./audioPlay";
import roomSetup from "./roomSetup";
import squatDrawing from "./squatDrawing";
import coneDrawing from "./coneDrawing";
import trackerActions from "./trackerActions";
import mouseActions from "./mouseActions";
import activityBuilderContent from "./activityBuilderContent";
import gridActions from "./gridActions";
import axiosVirdioT from './axios';

class whiteboard {

	constructor(args)
		{
			console.log(args, 'args');
			this.id = args['user_id'];
			this.elementDraw = new elementDrawing();
			this.soundPlay = window.soundPlay ? window.soundPlay : new audioPlay();
			this.roomSetup = new roomSetup(args);
			this.squatDraw = new squatDrawing();
			this.coneDraw = new coneDrawing();
			this.trackerActions = new trackerActions(args);
			window['trackerActions'] = this.trackerActions
			this.mouseActions = new mouseActions(args);
			this.gridActions = new gridActions(args);
			this.currentUserData = JSON.parse(localStorage.getItem("userData"));
			this.whiteboardValues = this.currentUserData.whiteboardValues;
			this.activityBuilderContent = new activityBuilderContent(this.whiteboardValues['activityBuilderObject']);
			this.globalEquipmentObject = JSON.parse(this.whiteboardValues['globalEquipmentObject']);
			this.currentActivityName = '';
			this.onDemand = false;
			this.guestUser = !!window['guestUser'];
			this.hostVirtual = false;
			this.hostVirtualOnMember = false;
			this.memberNoHostVirtual = false;
			this.hostVirtualReplay = false;
			this.loadWhiteboardLater = false;
			this.hasDrawnMultipleTimes = 0;
			this.hasDrawnMultipleTimesVirtual = '';
			this.objectChanges = [];
			this.leaderboardValues = this.currentUserData.leaderboardValues;
			this.personalBest = 0;
			this.counterPersBest = 0;
			this.sendMemberCounter = 0;
			this.savePersonalBest = [];
			//this.leaderboardValues = [];
			if ( args['host_virtual'] )
				{
					this.hostVirtual = true;
					console.log('load host virtual');
					
					if ( !window.allUsersList )
						{
							window.allUsersList = [];
						}
					
					window.allUsersList.push(this.id);
					
					window['usingPose'] = true;
					
					if ( window.currentActivity )
						{
							this.currentActivityName = window.currentActivity['name'];
						}
				}
				
			if ( args['host_virtual_member'] )
				{
					this.hostVirtualOnMember = true;
				}
				
			if ( args['host_virtual_ondemand'] )
				{
					this.memberNoHostVirtual = true;
				}
				
			if ( args['host_virtual_replay'] )
				{
					this.hostVirtualOnMember = true;
					this.memberNoHostVirtual = true;
					this.hostVirtualReplay = true;
					this.roomSetup.workoutAreaSetupDone = true;
				}
			
			this.poseDetection = new poseDetect(this.guestUser, this.hostVirtual);
			this.electron = window['electron'];
			console.log(window.$Any, 'check 111');
			this.$Any = window.$Any || {};
			this.$ = window.$ || {};
			this.tablete = window['tablete'];
			this.android = window['android'];
			this.useMediaPipe = parseInt(this.whiteboardValues.useMediaPipe);
			this.showMediaPipePoints = parseInt(this.whiteboardValues.showMediaPipePoints);
			this.poseDetection.useMediaPipe = this.useMediaPipe;
			
			this.audioElement = new Audio();
			
			window['stoodInZone'+this.id] = true;
			window['didHeightSound'] = false;
			window['allowHeightIncrease'] = false;
			window['participantRejoined'] = false;
			window['firstCircleShown'+this.id] = false;
			window['stoodInBox'+this.id] = false;
			window['showGreenCircle'+this.id] = false;

			this.timeInsideCircle = 0;
			this.usedTimeCircle = false;
			
			// **** Ovo se ne koristi
			
			window['plankLineTouched'] = false;
			this.circleSwitch = false;
			this.allowNextSwitch = true;
			this.allowNextSwitchResisted = true;
			window['showNextDrillCircle'+this.id] = false;
			this.pauseVideoDrawing = false;
			this.kneePoints = [25, 26];
			this.canvasRatio = 1;
			this.canvasRatio2 = 1;
			this.canvasRatio3 = 1;
			this.linesWidth = window['linesWidth'+this.id] ? window['linesWidth'+this.id] : this.whiteboardValues['lineW'];
			
			if ( !this.guestUser && !this.onDemand && !this.hostVirtual )
				{
					//window['ladderDraw'+this.id] = this.ladderDraw;
					window['rotateValue'+this.id] = this.whiteboardValues.middleBagHit;
					window['bagRotate'+this.id] = 0
					window['rotateIncrease'+this.id] = 0;
					window['changePos'+this.id] = false;
					window['animationPosition'+this.id] = [];
					this.loadElements();
					
					this.videl = this.$Any('#agora_remote_vdo'+this.id);
					this.canvasRatio = 1280 / 1000;
					window.canvasRatio = this.canvasRatio;
					console.log(this.canvasRatio, 'canvasRatio');
					
					this.linesWidth = this.linesWidth * this.canvasRatio;
					
					let mainThis = this;
					if ( window['roomSetupDone'+this.id] )
						{
							setTimeout(function(){
								window['roomAndHeightSetup'+mainThis.id]();
							}, 1000);
						}
						
					if ( !window.allUsersList )
						{
							window.allUsersList = [];
						}
					
					window.allUsersList.push(this.id);
				}
			else if ( this.guestUser || this.hostVirtual || this.onDemand || this.hostVirtualOnMember )
				{
					window['animationPosition'+this.id] = [];
					window['rotateValue'+this.id] = this.whiteboardValues.middleBagHit;
					window['bagRotate'+this.id] = 0;
					window['changePos'+this.id] = false;
					window['rotateIncrease'+this.id] = 0;
					this.loadElements();
					
					if ( this.currentUserData.sessionData.scriptDetail !== undefined && this.currentUserData.sessionData.scriptDetail.length > 0 )
						{
							this.scriptOn = true;
						}
					else
						{
							this.scriptOn = false;
						}
						
					if ( window['preStreamingWhite'] )
						{
							//this.roomSetup.startRoomSetup();
							//window.startRoomSetup();
						}
					
					this.canvasDiff = 1;
					this.canvasDiffH = 1;
					
					let mainThis = this;
					setTimeout(function(){
						mainThis.canvasDiff = this.$('#canvasWrap').width() / 1280;
						mainThis.canvasDiffH = this.$('#canvasWrap').height() / 720;
					}, 3000);
					
					if ( this.hostVirtual )
						{
							this.$('#imageCanvas').attr('style', 'transform: scaleX(-1) !important; left: 0 !important');
						}
				}
			else if ( this.onDemand )
				{
					window['rotateValue'+this.id] = this.whiteboardValues.middleBagHit;
					window['bagRotate'+this.id] = 0;
					window['changePos'+this.id] = false;
					window['rotateIncrease'+this.id] = 0;
					window['animationPosition'+this.id] = [];
					this.canvas = document.getElementById('sessionCanvas');
					this.imageCanvas = document.getElementById('imageCanvas');
					this.bufferCanvas = document.getElementById('bufferCanvas');
					this.ctx = this.canvas.getContext("2d");
					this.ctx3 = this.imageCanvas.getContext("2d");
					this.ctx4 = this.bufferCanvas.getContext("2d");
					this.editDot = document.getElementById('editDot');
					this.canvasWrap = document.getElementById('canvasWrap');
					
					this.videl = document.getElementById('local_preview');
					this.canvasRatio = 1280 / 1000;
					window.canvasRatio = this.canvasRatio;
					console.log(this.canvasRatio, 'canvasRatio');
					
				}
				
			this.addUpdateFlutterFunction();
			
			this.savedData = '';
			this.stopClear = false;
			this.pauseDrawing = false;
			this.savedData2 = '';
			this.gridData = '';
			window['didAnimationBag'+this.id] = false;
			window['animationStopped'+this.id] = false;
			window['openedEditEquipment'+this.id] = false;
			window['currentReaction'+this.id] = 0;
			window['showGridLines'] = false;
			
			this.bagAnimationInterval = 0;
			this.videoElementContext = false;
			this.points = [];
			this.lines = [];
			this.canvasLines = [];
			
			window['pixelItemStart'+this.id] = 0;
			window['pixelItemEnd'+this.id] = 0;
			
			this.sep = '~@$';
			this.pxPerMm = 3.75;
			this.gridColor = this.whiteboardValues.gridColor;
			this.draw0 = false;
			this.pixelDataZero = {};
			this.heightCaptured = false;
			this.screenshotList = this.guestUser ? document.getElementById('canvasScreenshotDrop'+this.id) : this.$Any('#canvasScreenshotDrop'+this.id)[0];
			this.notePopup = this.guestUser ? document.getElementById('canvasNotePopup') : this.$Any('#canvasNotePopup'+this.id)[0];
			this.pauseClick = false;
			this.chosenShareScreen = 0;
			this.clearPoints = [];
			this.lowest_point = 0;
			this.lowest_pointX = 0;
			this.bodyX = {};
			this.lowYBag = {};
			this.startOverSound = false;
			this.pixelData = 0;
			this.pixelDataBuff = 0;
			this.partLeftOld = 0;
			this.partRightOld = 0;
			this.partTopOld = 0;
			this.partBottomOld = 0;
			this.arrayBuffer = {};
			this.progressValHeight = 0;
			this.heightTimeoutNew = 0;
			this.pxPerMm = 3.75;
			this.workoutRegionX = 0;
			this.workoutRegionW = 0;
			this.trackerData = '';
			this.startRecTime = (new Date()).getTime();
			this.mediaRecorder1 = '';
			this.nowCountRec = 0;
			this.partStandingX = 0;
			this.partStandingY = 0;
			this.roomSetupCanvas = '';
			this.ctx5 = '';
			this.workoutSpaceTimeout = false;
			this.wentInsideWorkout = false;
			this.currentEquipment = '';
			this.newConesSize = {
				"newConeSmall": [76, 85],
				"newConeBig": [101, 111],
				"coneCircleSmall": [130, 44],
				"coneCircleBig": [172, 58]
			};
			this.workoutLineStartX = 0;
			this.workoutLineStartY = 0;
			this.workoutLineEndX = 0;
			this.workoutLineEndY = 0;
			this.movementTimeoutStarted = false;
			this.firstPixelData = '';
			this.sessionHasScript = this.currentUserData.sessionData.scriptDetail !== undefined && this.currentUserData.sessionData.scriptDetail.length > 0 ? true : false;
			this.nowCountRec2 = 0;
			this.lastRTMMessages = {};
			this.participantHeight2 = 500;
			this.mouseActions.whiteboard = this;
			this.trackerActions.whiteboard = this;
			this.globalActType = '';
			this.trackerActions.globalEquipmentObject = this.globalEquipmentObject;
			this.roomSetup.whiteboard = this;
			this.roomSetup.trackerActions = this.trackerActions;
			this.roomSetup.globalEquipmentObject = this.globalEquipmentObject;
			this.roomSetup.gridActions = this.gridActions;
			this.roomSetup.activityBuilderContent = this.activityBuilderContent;
			this.elementDraw.clearUpElement = this.clearUpElement;
			this.elementDraw.calculateAngle = this.mouseActions.calculateAngle;
			this.coneDraw.activityBuilderContent = this.activityBuilderContent;
			this.coneDraw.gridActions = this.gridActions;
			this.coneDraw.whiteboard = this;
			this.gridActions.whiteboard = this;
			this.startLocationFunction();
			this.boxJumpWidth = 0;
			this.boxJumpHeight = 0;
			this.plankWidth = 0;
			this.plankHeight = 0;
			this.plankReachWidth = 0;
			this.plankReachHeight = 0;
			this.perspectiveDiff = 1.25;
			this.circleObj = {};
			this.gridOn = false;
			this.gridCanvas = '';
			this.$ = window.$ || {};
			this.isDrawingStarted = false;
			this.bagToolTip = this.guestUser ? document.getElementById('bagToolTip'+this.id) : this.$Any('#bagToolTip'+this.id)[0];
			this.savedData = undefined;
			this.showDetectorsLine = parseInt(this.whiteboardValues.showDetectors);
			this.equipmentImages = {};
			this.globalCounter = 0;
			this.globalPerMinuteCounter = 0;
			this.globalNegativeCounter = 0;
			this.trackerRegion = {"x": 20, "y": 20, "width": 600, "height": 330};
			this.activeZoneSet = false;
			this.ifZoneRemoved = false;
			this.currentZoneSet = 0;
			this.sessionDataStore = window.sessionDataStore;
			this.Util =  window.Util;
			this.activityName = '';
			this.previousObjectRTM = {};
			this.previousObjectRTM2 = {};
			this.counterAll = 0;
			console.log('whiteboard test bottom');

			window['getImageDimensions'] = this.getImageDimensions;
			window['getBoxingCirclePosition'] = this.getBoxingCirclePosition;
			window['updateGridZone'] = this.updateGridZone;
			window['getRoomInstructions'] = this.getRoomInstructions;
			window['updateBagPositionCall'] = this.updateBagPositionCall;
	
			if ( !this.hostVirtualReplay ) { this.addFlutterWhiteboard(); }
			else 
				{
					if ( window['userCameraOff'] )
						{
							this.loadWhiteboardLater = true;
						}
					else
						{
							this.addFlutterWhiteboard();
						}
				}
			
			if ( window['userCameraOff'] )
				{
					if ( !window['changeGlobalCounter'] ) { window['changeGlobalCounter'] = this.changeGlobalCounter; }
					if ( !window['calculatePerMinuteCounter'] ) { window['calculatePerMinuteCounter'] = this.calculatePerMinuteCounter; }
				}
			
			if ( (this.guestUser && !this.hostVirtualOnMember) || this.hostVirtual || (this.onDemand && !this.memberNoHostVirtual) || (this.hostVirtualReplay && !this.currentUserData.sessionData.ondemandId) )
				{
					if ( !window['userCameraOff'] )
						{
							if ( !window['changeGlobalCounter'] ) { window['changeGlobalCounter'] = this.changeGlobalCounter; }
							if ( !window['calculatePerMinuteCounter'] ) { window['calculatePerMinuteCounter'] = this.calculatePerMinuteCounter; }
						}
					
					window['changeGlobalObject'] = this.changeGlobalObject;
					window['setStatsIcons'] = this.setStatsIcons;
					window['sendRTMFlutter'] = this.sendRTMFlutter;
					window['showMessageInstruction'] = this.showMessageInstruction;
					window['resetActivityObject'] = this.resetActivityObject;
					window['redoRoomSetup'] = this.redoRoomSetup;
					window.dartTest = this.dartTest;
					window.getAndDrawVideoElement = this.getAndDrawVideoElement;
					window['setTopAndBottomLine'] = this.setTopAndBottomLine;
					window['finishMediaPipeCalculation'] = this.finishMediaPipeCalculation;
					window['showMediaInterval'] = this.showMediaInterval;
					window['tiltCameraMessage'] = this.tiltCameraMessage;
				}
			if ( this.loadWhiteboardLater ) { this.addFlutterWhiteboard(); }
		}
	
	loadElements()
		{
			if ( !this.guestUser && !this.hostVirtual && !this.onDemand )
				{
					this.canvas = this.$Any('#sessionCanvas'+this.id)[0];
					this.imageCanvas = this.$Any('#imageCanvas'+this.id)[0];
					this.bufferCanvas = this.$Any('#bufferCanvas'+this.id)[0];
					this.ctx = this.canvas.getContext("2d");
					this.ctx3 = this.imageCanvas.getContext("2d");
					this.ctx4 = this.bufferCanvas.getContext("2d");
					this.editDot = this.$Any('#editDot'+this.id)[0];
					this.canvasWrap = this.$Any('#canvasWrap'+this.id)[0];
					this.highlightCanvas = this.$Any('#highlightCanvas'+this.id)[0];
				}
			else if ( this.guestUser || this.hostVirtual || this.onDemand || this.hostVirtualOnMember )
				{
					this.canvas = document.getElementById('sessionCanvas');
					this.imageCanvas = document.getElementById('imageCanvas');
					this.bufferCanvas = document.getElementById('bufferCanvas');
					this.ctx = this.canvas.getContext("2d");
					this.ctx3 = this.imageCanvas.getContext("2d");
					this.ctx4 = this.bufferCanvas.getContext("2d");
					this.editDot = document.getElementById('editDot');
					this.canvasWrap = document.getElementById('canvasWrap');
					
					this.activityCounter = document.getElementById('activityCounter');
					this.activityHolder = document.getElementsByClassName('w-50')[0];
					this.footer = document.getElementById('footerId');
				}
		}
	
	updateLocation()
		{
			if ( ( !this.guestUser && !this.hostVirtual && !this.onDemand ) && this.hasDrawnMultipleTimes > 5 && window.currentVirtualDraw == this.id )
				{
					this.$Any('#imageCanvas'+this.id).addClass('d-none');
					
					window.pendingVirtualDraw = false;
					/* var nextUser = window.currentVirtualDraw ? window.allUsersList.indexOf(window.currentVirtualDraw) + 1 : 0;
					if ( nextUser == window.allUsersList.length ) { nextUser = 0; }
					window.currentVirtualDraw = window.allUsersList[nextUser]; */
					
					window.currentVirtualDraw = this.currentUserData.id;
					
					return false; 
				}
			
			//if ( this.onDemand && this.memberNoHostVirtual && window['demandScriptName'] && this.globalActType && this.globalActType == 'boxing' ) { return false; }
			if ( !window.pauseVirtualActivityStarted && (this.hostVirtualOnMember || this.memberNoHostVirtual) ) { return false; }
			if ( window.pauseVirtualActivityStarted && !this.hostVirtualOnMember && !this.memberNoHostVirtual ) { return false; }
			if ( this.hostVirtual && this.$Any('#canvasWrap').hasClass('d-none') ) { return false; }
			if ( this.guestUser && this.$('#canvasWrap').hasClass('d-none') ) { return false; }
			if ( ( (!this.guestUser && !this.hostVirtual) && !this.onDemand ) && ( this.$Any('#sessionCanvas'+this.id).length < 1 || ( this.$Any('#sessionCanvas'+this.id).length > 0 && ( this.$Any('#sessionCanvas'+this.id)[0].width < 1 ||  this.$Any('#sessionCanvas'+this.id)[0].height < 1))) && window.currentVirtualDraw == this.id ) 
				{ 
					window.pendingVirtualDraw = false;
					var nextUser = window.currentVirtualDraw ? window.allUsersList.indexOf(window.currentVirtualDraw) + 1 : 0;
					if ( nextUser == window.allUsersList.length ) { nextUser = 0; }
					window.currentVirtualDraw = window.allUsersList[nextUser];
					return false; 
				}
			if ( !this.guestUser && !this.onDemand && ( (this.id != window.currentVirtualDraw && window.currentVirtualDraw != undefined) || window.pendingVirtualDraw ) ) { return false; }
			
			if ( window.currentVirtualDraw == this.id )
				{
					this.hasDrawnMultipleTimes++;
				}
			
			var videoElement = this.getVideoElement();
			if ( videoElement && (this.guestUser || this.hostVirtual || this.onDemand) )
				{
					this.drawCanvasFromVideoElement(videoElement);
				}
			
			if ( videoElement )
				{
					if ( !window.pauseVirtualActivityStarted && this.$('#canvasWrap').hasClass('hostVirtualOnMember') ) { console.log('canvasWrap1'); this.$('#canvasWrap').removeClass('hostVirtualOnMember'); }
					if ( window.pauseVirtualActivityStarted && !this.onDemand && !this.$('#canvasWrap').hasClass('hostVirtualOnMember') ) { console.log('canvasWrap2'); this.$('#canvasWrap').addClass('hostVirtualOnMember'); }
					if ( this.canvasLines.length > 0 )
						{
							this.drawLines();
						}
						
					if ( window.updateDrawingUser && this.canvasLines.length < 1 )
						{
							window.pendingVirtualDraw = true;
							
							window.updateDrawingUser(this.id);
						}
					
					if ( (this.guestUser && !this.hostVirtualOnMember) || this.hostVirtual || (this.onDemand && !this.memberNoHostVirtual) )
						{
							if ( this.trackerActions.isTrackerBgSet ) { this.trackerActions.getParticipantPosition(); }
						}
				}
		}
	
	startLocationFunction()
		{
			let mainThis = this;
			this.updateInterval = setInterval(function(){ 
				mainThis.updateLocation();
			}, 30);
			
			if ( !this.hostVirtualOnMember )
				{
					this.perMinuteInterval = setInterval(function(){ 
						mainThis.calculatePerMinuteCounter();
					}, 1000);
				}
		}
	
	showMessageInstruction = (message, imageLink, innerText, buttonImage, buttonText, upNext, showLoader) =>
		{
			if ( this.guestUser || this.onDemand || this.hostVirtual )
				{
					if ( imageLink ) 
						{
							this.$Any('#partToolTip .tooltipImage').css('background-image', imageLink);
							this.$Any('#partToolTip .tooltipImage').removeClass('d-none');
							
							this.$Any('#toolTip .tooltipImage').css('background-image', imageLink);
							this.$Any('#toolTip .tooltipImage').removeClass('d-none');
						}
					else
						{
							this.$Any('#partToolTip .tooltipImage').addClass('d-none');
							this.$Any('#toolTip .tooltipImage').addClass('d-none');
						}
						
					if ( innerText ) 
						{
							this.$Any('#partToolTip .part_inner').removeClass('d-none'); 
							this.$Any('#partToolTip .part_inner').html(innerText);
							
							this.$Any('#toolTip .part_inner').removeClass('d-none'); 
							this.$Any('#toolTip .part_inner').html(innerText);
						}
					else
						{
							this.$Any('#partToolTip .part_inner').addClass('d-none'); 
							this.$Any('#partToolTip .part_inner').html(0);
							
							this.$Any('#toolTip .part_inner').addClass('d-none'); 
							this.$Any('#toolTip .part_inner').html(0);
						}
					
					if ( buttonImage && buttonText )
						{
							this.$Any('#walkToolImage .walk_tool_image').css('background-image', "url(images/"+buttonImage+")");
							this.$Any('#walkToolImage .walk_tool_text').html(buttonText);
							this.$Any('#walkToolImage').removeClass('d-none');
						}
					else
						{
							this.$Any('#walkToolImage').addClass('d-none');
						}
					
					if ( upNext )
						{
							this.$Any('#upNextText').removeClass('d-none');
							this.$Any('#upNextText').html('UP NEXT:');
						}
					else
						{
							this.$Any('#upNextText').addClass('d-none');
							this.$Any('#upNextText').html();
						}
					
					if ( showLoader )
						{
							this.$Any('.room_setup_loader').removeClass('d-none');
						}
					else
						{
							this.$Any('.room_setup_loader').addClass('d-none');
						}
					
					this.$Any('#partToolTip .tooltipText').html(message);
					this.$Any('#partToolTip').removeClass('d-none');
				
					this.$Any('#toolTip .tooltipText').html(message);
					this.$Any('#toolTip').removeClass('d-none');
				}
			else
				{
					if ( imageLink ) 
						{
							this.$Any('#partToolTip .tooltipImage').css('background-image', imageLink);
							this.$Any('#partToolTip .tooltipImage').removeClass('d-none');
						}
					else
						{
							this.$Any('#partToolTip .tooltipImage').addClass('d-none');
						}
					
					if ( innerText ) 
						{
							this.$Any('#innerPartText').removeClass('d-none'); 
							this.$Any('#innerPartText').html(innerText);
						}
						
					if ( showLoader )
						{
							this.$Any('.room_setup_loader').removeClass('d-none');
						}
					else
						{
							this.$Any('.room_setup_loader').addClass('d-none');
						}
					
					this.$Any('#newToolTip').removeClass('d-none');
					this.$Any('#newToolTip').find('.tooltipText').html(message);
				}
		}
	
	clearMessageInstructions()
		{
			this.$Any('#partToolTip').addClass('d-none');
			this.$Any('#toolTip').addClass('d-none');
		}
		
	getVideoElement() 
		{
			var videoElement = false;
				
			if ( this.electron )
				{
					if ( this.guestUser )
						{
							if ( window['preStreamingWhite'] )
								{
									for ( var i = 0; i < window.$('#local-media').find('canvas').length; i++ )
										{
											if ( !window.$('#local-media').find('canvas')[i].hasAttribute('id') )
												{
													videoElement = window.$('#local-media').find('canvas')[i];
												}
										}
								}
							else if ( this.hostVirtualOnMember )
								{
									if ( this.currentUserData.sessionData.replayClassId > 0 || this.currentUserData.sessionData.ondemandId > 0 ) { videoElement = window.$('#host_stream').find('video')[0] }
									else { videoElement = window.$('#host_stream').find('canvas')[0]; }
								}
							else
								{
									videoElement = window.$('#mystream').find('canvas')[0];
								}
						}
						
					else if ( this.hostVirtual )
						{
							if ( window['preStreamingWhite'] )
								{
									for ( var i = 0; i < window.$('#local-media').find('canvas').length; i++ )
										{
											if ( !window.$('#local-media').find('canvas')[i].hasAttribute('id') )
												{
													videoElement = window.$('#local-media').find('canvas')[i];
												}
										}
								}
							else
								{
									videoElement = this.$('#host_video').find('canvas')[0];
								}
						}
						
					else if ( this.onDemand )
						{
							videoElement = window.$('#local_preview')[0];
						}
					
					else
						{
							videoElement = window.$Any('#agora_remote_vdo'+this.id).find('canvas')[0];
						}
				}
			else
				{
					if ( this.onDemand )
						{
							videoElement = window.$('#local_preview')[0];
						}
					else if ( window['preStreamingWhite'] )
						{
							videoElement = window.$('#local-media').find('video')[0];
						}
					else
						{
							videoElement = this.guestUser ? document.getElementById('video'+this.id) : this.$Any('#video'+this.id)[0];
						}
				}
				
			return videoElement;
		}
	
	drawCanvasFromVideoElement(videoElement, context)
		{
			if ( !videoElement || ( videoElement && (videoElement.width < 1 || videoElement.height < 1) && !videoElement.videoHeight ) ) { return false; }
			
			let useCtx = this.ctx3;
			if ( context ) { useCtx = context; }
			
			var vheight = videoElement.height;
			var vwidth = videoElement.width;
			
			useCtx.clearRect(0,0,this.imageCanvas.width,this.imageCanvas.height);
			
			if ( videoElement.videoHeight )
				{
					useCtx.drawImage(videoElement, 0, (this.imageCanvas.height-videoElement.videoHeight * (this.imageCanvas.width/videoElement.videoWidth))/2, this.imageCanvas.width, videoElement.videoHeight * (this.imageCanvas.width/videoElement.videoWidth));
				}
			else if ( vheight && vwidth )
				{
					var newCX = 0;
					var newWidth = vwidth;
					var newHeight = vwidth*(9/16);
					if ( newHeight > vheight )
						{
							newHeight = vheight;
							newWidth = vheight * (16/9);
						}
					
					var newCX = (vwidth-newWidth)/2;
					var newCY = (vheight-newHeight)/2;
					useCtx.drawImage(videoElement, Math.floor(newCX), Math.floor(newCY), Math.floor(newWidth), Math.floor(newHeight), 0, 0, this.imageCanvas.width, this.imageCanvas.height);
				}
			else
				{
					useCtx.drawImage(videoElement, 0, 0, this.imageCanvas.width, this.imageCanvas.height);
					console.log('no canvas #1');
				}
				
			if ( this.$Any('#imageCanvas'+this.id).hasClass('d-none') || this.$Any('#imageCanvas').css('display') == 'none' )
				{
					this.$Any('#imageCanvas'+this.id).removeClass('d-none');
					this.$Any('#imageCanvas').css("display", "block");
				}
		}
		
	getAndDrawVideoElement = () =>
		{
			var videoElement = this.getVideoElement();
			if ( videoElement )
				{
					this.drawCanvasFromVideoElement(videoElement);
				}
		}
		
	findClearPoints()
		{
			var diffWidthStart = 0;
			var diffWidth = this.imageCanvas.width;
			var increaseValue = 4;
			var foundLowestPoint = false;
			var maxLowestCheck = this.imageCanvas.height / 3;
			var pixel = this.ctx3.getImageData(0, 0, this.imageCanvas.width, this.imageCanvas.height);
			this.pixelData = pixel.data;
			this.clearPoints = [];
			this.bodyX = {};
			
			if ( this.electron && this.roomSetup.alreadyMeasured && (window['pixelItemEnd'+this.id] > window['pixelItemStart'+this.id]) && !this.roomSetup.workoutAreaProcess ) 
				{ 
					diffWidthStart = window['pixelItemStart'+this.id]; diffWidth = window['pixelItemEnd'+this.id]; 
				}
			if ( this.electron && this.roomSetup.alreadyMeasured && this.roomSetup.workoutAreaProcess && this.trackerActions.partLeft > 0 && this.trackerActions.partRight > 0 ) 
				{ 
					diffWidthStart = this.trackerActions.partLeft; diffWidth = this.trackerActions.partRight; 
				}
			
			for ( var i = this.imageCanvas.height; i > 3; i -= increaseValue )
				{
					for ( var j = diffWidthStart; j < diffWidth; j+=increaseValue )
						{
							var indexZero = (i*this.imageCanvas.width*increaseValue)+(j*increaseValue);
							
							var diff1 = Math.abs(this.pixelData[indexZero]-this.pixelDataZero[indexZero]);
							var diff2 = Math.abs(this.pixelData[indexZero+1]-this.pixelDataZero[indexZero+1]);
							var diff3 = Math.abs(this.pixelData[indexZero+2]-this.pixelDataZero[indexZero+2]);
							
							var valdif = 70;
							
							if ( diff1 > valdif || diff2 > valdif || diff3 > valdif )
								{
									if ( !foundLowestPoint && !this.guestUser )
										{
											if ( i > maxLowestCheck )
												{
													if ( this.checkExistNearPixel(i-(increaseValue*3), j, increaseValue, this.pixelData) && this.checkExistNearPixel(i-increaseValue, j-increaseValue, increaseValue, this.pixelData) && this.checkExistNearPixel(i-increaseValue, j+increaseValue, increaseValue, this.pixelData) )
														{
															this.lowest_point = i;
															this.lowest_pointX = j;
															
															foundLowestPoint = true;
														}
												}
										}
									
									this.clearPoints.push([j, i]);
									if ( !this.bodyX[j] )
										{
											this.bodyX[j] = 0;
										}
									this.bodyX[j]++;
								}
						}
				}
			
			if ( this.clearPoints.length < 100 ) { this.lowest_point = 0; this.lowest_pointX = 0; this.clearPoints = []; }
		}
		
	checkExistNearPixel(i, j, increaseValue, pixelData)
		{
			var indexZero = (i*this.imageCanvas.width*increaseValue)+(j*increaseValue);
			
			if ( isNaN(indexZero) ) { return false; }
			
			var diff1 = Math.abs(pixelData[indexZero]-this.pixelDataZero[indexZero]);
			var diff2 = Math.abs(pixelData[indexZero+1]-this.pixelDataZero[indexZero+1]);
			var diff3 = Math.abs(pixelData[indexZero+2]-this.pixelDataZero[indexZero+2]);
			
			var valdif = 70;
			
			// Outside of screen
			if ( isNaN(diff1) || isNaN(diff2) || isNaN(diff3) ) { return false; }
			
			if ( diff1 > valdif || diff2 > valdif || diff3 > valdif )
				{
					return true;
				}
			
			return false;
		}
	
	clearUpElement(x, y, w, h, behind)
		{
			if ( ( ( !this.draw0 || !this.hasEquipment || this.mouseActions.mouseDown ) && !this.measuringProcess && !this.workoutAreaProcess ) || ( ( !this.draw0 || this.mouseActions.mouseDown ) && this.measuringProcess ) ) { return true; }
			var lowestCone = y + h;
			if ( lowestCone < this.lowest_point || behind )
				{
					for ( var dl of this.clearPoints )
						{
							if ( dl[0] > x-1 && dl[0] < x + w && dl[1] > y-1 && dl[1] < y + h )
								{
									this.ctx.clearRect(dl[0], dl[1], 4, 4);
								}
						}
				}
		}
		
	inToFt(inch) 
		{
			var inches = Math.round(inch);
			var feet = Math.floor(inches / 12);
			inches %= 12;
			
			var sizeText = inch < 12 ? (Math.floor(inch) + '"') : (feet + "'" + inches + '"');
			
			return sizeText;
		}
		
	drawLines() 
		{
			if ( !this.ctx ) { return false; }
			
			if ( !this.stopClear ) 
				{ 
					this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height); 
				}
			let mainThis = this;
				
			if ( window['drawWorkoutZone'] && this.roomSetup.workoutAreaSetupDone )
				{
					this.ctx.beginPath();
					this.ctx.moveTo(this.roomSetup.workoutConeLocation['bottomLeft']['posX'], this.roomSetup.workoutConeLocation['bottomLeft']['posY']);
					this.ctx.lineTo(this.roomSetup.workoutConeLocation['bottomRight']['posX'], this.roomSetup.workoutConeLocation['bottomRight']['posY']);
					this.ctx.lineTo(this.roomSetup.workoutConeLocation['topRight']['posX'], this.roomSetup.workoutConeLocation['topRight']['posY']);
					this.ctx.lineTo(this.roomSetup.workoutConeLocation['topLeft']['posX'], this.roomSetup.workoutConeLocation['topLeft']['posY']);
					this.ctx.lineTo(this.roomSetup.workoutConeLocation['bottomLeft']['posX'], this.roomSetup.workoutConeLocation['bottomLeft']['posY']);
					this.ctx.strokeStyle = 'red';
					this.ctx.stroke();
					this.ctx.closePath();
				}
				
			var touchingElement = false;
			var touchingElement2 = false;
			var touchingElements = {'r': false, 'l': false};
			var cleanUpLines = [];
			var inSameLine = false;
			var hasInside = false;
			var hasOutside = false;
			
			var mainthis = this;
			this.canvasLines.forEach(function(item, index) {
				if ( (mainthis.guestUser || mainthis.workoutAreaProcess ) && item['hidden'] && !item['workoutC'] && !item['roomC'] ) { return; }
				if ( item['stPoint'] )
					{
						var lineStructure = {'moveX': item['stPoint'].x, 'moveY': item['stPoint'].y, 'lineX': item['endPoint'].x, 'lineY': item['endPoint'].y, 'strokeColor': item['cl'], 'lineWidth': item['lineW']};
						mainthis.elementDraw.mainLineDraw(mainthis.ctx, lineStructure);
					}
				else if ( item['t'] == 'r' )
					{
						mainthis.ctx.strokeStyle = item['cl'];
						mainthis.ctx.lineWidth = item['lineW'];
						mainthis.ctx.strokeRect(item.startX, item.startY, item.w, item.h);
						
						if ( item['cmH'] > 0 )
							{
								var textSide = item.w < 0 ? item.startX - 60 : item.startX + item.w - 60;
								var heightText = mainthis.inToFt(item['cmH']);
								
								var textStructure = {'text': heightText, 'startX': textSide, 'startY': item.startY + item.h/2 + 10, 'font': 'bold 25px Arial', 'strokeColor': '#000', 'fillStyle': item['cl'], 'lineWidth': 4};
								mainthis.elementDraw.writeText(mainthis.ctx, textStructure);
							}
						else if ( item['cmH'] == -1 )
							{
								var rectSize = mainthis.calcHeight(item);
											
								item['cmH'] = rectSize['h'];
								item['cmW'] = rectSize['w'];
							}
						
						if ( mainthis.canvas.height - mainthis.lowest_point > 10 )
							{
								var diffY = Math.abs(item.startY+item.h - mainthis.lowest_point);
								var lineWidth = diffY > 150 ? 3 : diffY > 100 ? 6 : diffY > 75 ? 9 : 12;
								
								var lineStructure = {'moveX': 0, 'moveY': item.startY+item.h-(lineWidth/2), 'lineX': mainthis.canvas.width, 'lineY': item.startY+item.h-(lineWidth/2), 'strokeColor': item['cl'], 'lineWidth': item['lineW']};

								mainthis.elementDraw.mainLineDraw(mainthis.ctx, lineStructure);
							}
					}
				else if ( item['t'] == 'c' )
					{
						if ( !mainthis.guestUser && (item['heightC'] || item['workoutC'] || item['roomC']) )
							{
								var inHeightCheck = {'lowestpointX': mainthis.lowest_pointX, 'leftSideOfSpace': item.x1, 'rightSideOfSpace': item.x2, 'lowest_point': mainthis.lowest_point, 'topSide':  item.y1, 'bottomSide': item.y2};
								let newDesign = false;
								var checkInSpace = mainthis.squatDraw.checkIfInSpace(inHeightCheck, checkInSpace);
								if ( item['roomC'] ) { newDesign = true; }
								if ( item['workoutC'] ) { checkInSpace = false; newDesign = true; }
								mainthis.elementDraw.targetCircle(mainthis.id, mainthis.ctx, inHeightCheck, checkInSpace, newDesign);
							}
							
						if ( !item['heightC'] && !item['workoutC'] && !item['roomC'] )
							{
								mainthis.drawEllipse(item['x1'], item['y1'], item['x2'], item['y2'], item['cl'], item['lineW']);
								var lineStructure = {'moveX': 0, 'moveY': item.y1, 'lineX': mainthis.canvas.width, 'lineY': item.y1, 'strokeColor': item['cl'], 'lineWidth': item['lineW']};
								if ( item.y1 < item.y2 )
								{
									lineStructure.moveY = item.y2;
									lineStructure.lineY = item.y2;
								}
								mainthis.elementDraw.mainLineDraw(mainthis.ctx, lineStructure);
							}							
					}
				else if ( Array.isArray(item) )
					{
						item.forEach(function(item2, index) {
							if ( item2['x1'] )
								{
									if ( index > 0 )
										{
											if ( index == 1 )
												{
													mainthis.ctx.beginPath();
													mainthis.ctx.moveTo(item2['x1'], item2['y1']);
												}
											
											mainthis.ctx.lineTo(item2['x2'], item2['y2']);
											
											if ( index == item.length -1 )
												{
													mainthis.ctx.strokeStyle = item2['cl'];
													mainthis.ctx.lineWidth = item2['lineW'];
													mainthis.ctx.stroke();
													mainthis.ctx.closePath();
												}
										}
								}
							else
								{
									if ( item.length > 2 )
										{
											mainthis.ctx.beginPath();
											mainthis.ctx.moveTo(item[0].x, item[0].y);
											mainthis.ctx.lineTo(item[1].x, item[1].y);
											mainthis.ctx.moveTo(item[0].x, item[0].y);
											mainthis.ctx.lineTo(item[2].x, item[2].y);
											mainthis.ctx.lineWidth = item[0]['lineW'];
											mainthis.ctx.strokeStyle = item2['cl'];
											mainthis.ctx.stroke();
											var textStructure = {'text': item[2]['deg']+'°', 'startX': item[0].x + 10, 'startY': item[0].y + 10, 'font': 'bold 25px Arial', 'strokeColor': '#000', 'fillStyle': item[2]['cl'], 'lineWidth': 4};
											mainthis.elementDraw.writeText(mainthis.ctx, textStructure);
											mainthis.ctx.closePath();
										}
								}
						});
					}
			});
			
			this.updateLines(this.canvasLines);
			
			if ( this.showMediaPipePoints && this.useMediaPipe && window['poseDots'] )
				{
					this.drawMediaPipeDots();
				}
		}
		
	drawVirtualEquipment()
		{
			if ( !this.globalActType || ( this.globalActType && this.globalActType != 'workoutAreaSetup' && !this.roomSetup.workoutAreaSetupDone ) ) { return false; }
			
			var mainthis = this;
			var currentActivity = this.activityBuilderContent.activityBuilderObject[this.globalActType];
			currentActivity.drawingObjects.forEach(function(item, index) {
				if ( !item['isHidden'] )
					{
						var imageObject = mainthis.getImageObject(item, true);
						mainthis.drawActiveZones(item, imageObject);
						
						if ( item['image'] && item['image'] != 'customPath' )
							{
								var imgDraw = mainthis.getImage(item['isActive'] ? item['imageActive'] : item['image']);
								if ( item['image'] ) { mainthis.ctx.drawImage(imgDraw, imageObject['x'], imageObject['y'], imageObject['w'], imageObject['h']); }
							}
					}
			});
			
			if ( this.gridActions.gridBoxes.length > 0 && window['showGridLines'] )
				{
					this.gridActions.gridBoxes.forEach(function(item, index) {
						mainthis.ctx.beginPath();
						mainthis.ctx.moveTo(item['x1'], item['y1']);
						mainthis.ctx.lineTo(item['x2'], item['y1']);
						mainthis.ctx.lineTo(item['x2'], item['y2']);
						mainthis.ctx.lineTo(item['x1'], item['y2']);
						mainthis.ctx.lineTo(item['x1'], item['y1']);
						mainthis.ctx.lineWidth = 10;
						mainthis.ctx.strokeStyle = 'green';
						mainthis.ctx.stroke();
						mainthis.ctx.closePath();
					});
				}
		}
	
	getImage(img_url)
		{
			if ( !this.equipmentImages[img_url] )
				{
					var newImg = new Image();
					newImg.src = img_url;
					
					this.equipmentImages[img_url] = newImg;
				}
			
			return this.equipmentImages[img_url];
		}
	
	getImageObject(item, increaseSize)
		{
			var currentActivity = this.activityBuilderContent.activityBuilderObject[this.globalActType];
			var gridBox = this.gridActions.getGridZone(item['gridBox']-1);
			var imageSize = this.calculatePerspectiveSize(gridBox['y2'], item['defaultWidth'], item['defaultHeight']);
			var imageW = imageSize[0];
			var imageH = imageSize[1];
			var imageXDiff = 0;
			
			if ( item['isActive'] && increaseSize )
				{
					imageW = imageSize[0]*currentActivity['markedObjectIncrease'];
					imageH = imageSize[1]*currentActivity['markedObjectIncrease'];
					imageXDiff = imageSize[0]*currentActivity['markedObjectIncrease'] - imageSize[0];
				}
			
			var imageX = gridBox['x1'];
			var imageY = gridBox['y2'] - imageH;
			
			if ( item['gridAlign'] == 'left' )
				{
					imageX = gridBox['x1'] - imageXDiff;
					imageY = gridBox['y2'] - imageH;
				}
			else if ( item['gridAlign'] == 'right' )
				{
					imageX = gridBox['x2'] - imageW + imageXDiff;
					imageY = gridBox['y2'] - imageH;
				}
			else if ( item['gridAlign'] == 'leftTop' )
				{
					imageX = gridBox['x1'] - imageXDiff;
					imageY = gridBox['y1'];
				}
			else if ( item['gridAlign'] == 'rightTop' )
				{
					imageX = gridBox['x2'] - imageW + imageXDiff;
					imageY = gridBox['y1'];
				}
			else if ( item['gridAlign'] == 'leftBottom' )
				{
					imageX = gridBox['x1'] - imageXDiff;
					imageY = gridBox['y2'];
				}
			else if ( item['gridAlign'] == 'rightBottom' )
				{
					imageX = gridBox['x2'] - imageW + imageXDiff;
					imageY = gridBox['y2'];
				}
			
			if ( item['imageOffset'] )
				{
					imageX = imageX + (imageW*item['imageOffset'][0]);
					imageY = imageY + (imageH*item['imageOffset'][1]);
				}
			
			var imageCenterX = imageX;
			var imageCenterY = imageY;
			
			if ( item['imageCenterOffset'] )
				{
					imageCenterX = imageX + (imageW*item['imageCenterOffset'][0]);
					imageCenterY = imageY + (imageH*item['imageCenterOffset'][1]);
				}
			
			return {'x': imageX, 'y': imageY, 'w': imageW, 'h': imageH, 'centerX': imageCenterX, 'centerY': imageCenterY};
		}
		
	getActiveZone(zone)
		{
			if ( !zone['gridZone'] )
				{
					var cIndex = 0;
					var zIndex = zone;
					var currentActivity = this.activityBuilderContent.activityBuilderObject[this.globalActType];
					currentActivity.drawingObjects.forEach(function(item, index) {
						if ( item['activeZone'] )
							{
								item['activeZone'].forEach(function(item2, i) {
									if ( cIndex == zIndex )
										{
											zone = item2;
										}
									cIndex++;
								});
							}
					});
				}
				
			var gridBox = this.gridActions.getGridZone(zone['gridZone']-1);
			
			var gridWidth = gridBox['x2'] - gridBox['x1'];
			var zoneX1 = gridBox['x1'];
			var zoneX2 = gridBox['x2'];
			var zoneY1 = gridBox['y1'];
			var zoneY2 = gridBox['y2'];
			
			if ( zone['gridAlign'] == 'right' )
				{
					zoneX1 = gridBox['x1'];
					zoneX2 = gridBox['x1'] + (gridWidth/100)*zone['width'];
				}
			else if ( zone['gridAlign'] == 'left' )
				{
					zoneX1 = gridBox['x2'] - (gridWidth/100)*zone['width'];
					zoneX2 = gridBox['x2'];
				}
			else if ( zone['gridAlign'] == 'center' )
				{
					zoneX1 = gridBox['x2'] - (gridWidth/100)*zone['width'];
					zoneX2 = gridBox['x1'] + (gridWidth/100)*zone['width'];
				}
			
			var zoneCenterX = zoneX1;
			var zoneCenterY = zoneY1;
			
			var zoneCenterX = zoneX1 + ((zoneX2 - zoneX1) / 2);
			var zoneCenterY = zoneY1 + ((zoneY2 - zoneY1) / 2);
			
			return {'x': zoneX1, 'y': zoneY1, 'w': zoneX2 - zoneX1, 'h': zoneY2 - zoneY1, 'centerX': zoneCenterX, 'centerY': zoneCenterY};
		}
		
	calculatePerspectiveSize(y, width, height)
		{
			var itemDist = parseFloat((((y) / (this.canvas.height/2)) - 1).toFixed(2));
			if ( itemDist < 0.2 ) { itemDist = 0.2 }
			
			var itemWidth = Math.round(width * itemDist);
			var itemHeight = Math.round(height * itemDist);
			
			return [itemWidth, itemHeight];
		}
		
	calcHeight(item) 
		{
			var itemH = item['h'];
			var itemY = item['startY'];
			
			if ( itemH < 0 )
				{
					itemH = itemH * -1;
					itemY = itemY - itemH;
				}
			
			var dist = parseFloat((((itemY + itemH) / (this.canvas.height/2)) - 1).toFixed(2));
			var itemHeight = itemH;
			var itemWidth = item['w'];
			var objectWidth = parseInt(itemWidth * (this.pxPerMm/dist))/10;
			var objectHeight = parseInt(itemHeight * (this.pxPerMm/dist))/10;
			var finalWidth = Math.abs(((objectWidth)/2.54)).toFixed(1);
			var finalHeight = Math.abs(((objectHeight)/2.54)).toFixed(1);
			
			if ( dist < 0.2 ) { finalHeight = 0 }
			
			if ( !window['heightCaptured'] ) { finalHeight = -1 }
			
			var obj = {
				'h' : finalHeight,
				'w' : finalWidth
			};
			
			return obj;
		}
		
	updateLines(lines)
		{
			this.canvasLines = lines;
		}
	
	resetCanvas()
		{
			let mainThis = this;
			this.canvasLines = [];
			if ( this.ctx ) { this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height); }
			if ( this.ctx2 ) { this.ctx2.clearRect(0, 0, this.canvas.width, this.canvas.height); }
			if ( this.ctx3 ) { this.ctx3.clearRect(0, 0, this.canvas.width, this.canvas.height); }
			window['hasEquipment'+this.id] = false;
			this.clearPoints = [];
			this.lowest_point = 0;
			this.lowest_pointX = 0;
			
			clearInterval(mainThis.bagAnimationInterval);
			
			if ( !this.guestUser && !this.hostVirtual )
				{
					this.mouseActions.deleteBackground();
					window.$Any('#bagToolTip'+this.id).addClass('d-none');
					
					if ( window['gridOn'+this.id] ) { window['gridOn'+this.id] = false; window['globalRTM'](window['allPartDetails'][this.id]['email'], 'grid'+this.sep+(window['gridOn'+this.id] ? 1 : 0 )+this.sep+this.gridColor); }
				}
			else
				{
					window.$Any('#partToolTip').addClass('d-none');
					clearInterval(mainThis.zeroTimer);
					clearInterval(mainThis.heightTimer);
				}
		}
			
	drawMediaPipeDots()
		{
			var mainthis = this;
			
			/* this.ctx.beginPath();
			this.ctx.lineWidth = '6';
			this.ctx.strokeStyle = 'green'; */
			
			window['poseDots'].forEach(function (itm)
				{
					mainthis.ctx.fillStyle = 'green';
					mainthis.ctx.fillRect(itm.x*2, itm.y*2, 5, 5);
				});
			
			/* if ( window['poseDotsCross'] && !window.isPaused && ( this.currentEquipment == 'cone' || this.currentEquipment == 'cone_diagonal' ) )
				{
					this.ctx.fillRect(window['poseDotsCross']*2, 0, 2, 720);
				}
			
			if ( window['poseSpaceCheck'] && window['poseSpaceCheck']['ul_col'] )
				{
					this.ctx.moveTo(window['poseSpaceCheck']['ul_col']*2, window['poseSpaceCheck']['ul_row']*2);
					this.ctx.lineTo(window['poseSpaceCheck']['ur_col']*2, window['poseSpaceCheck']['ur_row']*2);
					this.ctx.lineTo(window['poseSpaceCheck']['lr_col']*2, window['poseSpaceCheck']['lr_row']*2);
					this.ctx.lineTo(window['poseSpaceCheck']['ll_col']*2, window['poseSpaceCheck']['ll_row']*2);
					this.ctx.lineTo(window['poseSpaceCheck']['ul_col']*2, window['poseSpaceCheck']['ul_row']*2);
					
					if ( window['zoneLowestPoint'] && window['zoneLowestPoint']['x'] )
						{
							this.ctx.rect((window['zoneLowestPoint']['x']*2) - 5, (window['zoneLowestPoint']['y']*2) - 5, 10, 10);
						}
				} 
			this.ctx.stroke();
			this.ctx.closePath();*/
		}
	
	saveCurrentCanvasAsPNG(subtext)
		{
			if ( !window['saveRecPath'] ) { return false; }
		
			var dataURL = this.bufferCanvas.toDataURL();
			if ( dataURL )
				{
					var dataa = dataURL.split(',')[1];
					
					if ( dataa )
						{
							this.nowCountRec2++;
							let uniq = 'rec_' + this.nowCountRec + '_' + this.nowCountRec2 + '_' + (new Date()).getTime() + '_' + subtext + '.png';
							var fullPath = window['saveRecPath']+uniq;
							
							var nowTimeR = (new Date()).getTime();
							this.trackerData = this.trackerData + (nowTimeR-this.startRecTime) + 's : ' +Math.floor((nowTimeR-this.startRecTime)/33) +'  PNG: ' + uniq + "\n";
							
							window['fsFile'].writeFile(fullPath, dataa, 'base64', function (err)
								{
									if ( !window['fsFile'].existsSync(fullPath) )
									{
										console.log('File not saved #1');
										alert('file not saved #1');
									}
								});
						}
				}
		}
		
	sendNewRTMMessage(message, mtype)
		{
			if ( ( !this.lastRTMMessages[mtype] || this.lastRTMMessages[mtype] !== message ) && !this.onDemand )
				{
					window['globalRTM'](this.currentUserData['sessionData']['hostEmail'], message);
					this.lastRTMMessages[mtype] = message;
				}
		}
	
	splitRTMSend(userId, message)
		{
			if ( !window['globalRTM'] ) { return; }
			
			var sep = '~@$';
			
			if ( message.length > 30 * 1024 )
				{
					var message2 = btoa(message);
					var splitArray = message2.match(/.{1,30000}/g);
					
					var uniqueCode = ((new Date()).getTime()+'_'+Math.random(0, 1000));
					
					for ( var sitem in splitArray )
						{
							var sendText = 'drawSplit' +sep+ uniqueCode +sep+ splitArray.length +sep+ sitem +sep+ splitArray[sitem];
							//console.log('send text', sendText);
							
							if ( this.hostVirtual )
								{
									window['sendMessageToChannel'](sendText + sep);
								}
							else
								{
									window['globalRTM'](userId, sendText);
								}
						}
				}
			else
				{
					if ( this.hostVirtual )
						{
							window['sendMessageToChannel'](message + sep);
						}
					else
						{
							window['globalRTM'](userId, message);
						}
				}
		}
		
	sendDrawRTM(email)
		{
			if ( this.hostVirtual ) { return false; }
			
			var message = 'draw'+this.sep+JSON.stringify(this.canvasLines);
			this.splitRTMSend(email, message);
		}
		
	resetEquipmentZones()
		{
			window['ladderZoneSet'] = false;
			window['coneZoneSet'] = false;
			window['coneZoneSetDiag'] = false;
			window['boxingZoneSet'] = false;
			
			this.splitRTMSend(window['allPartDetails'][this.id]['email'], 'resetEquipmentZones'+this.sep);
		}
		
	drawArrowsAndLines(arrows, lines, arrowSide)
		{
			var workoutLineStructure = {'moveX': lines['moveX'], 'moveY': lines['moveY'], 'lineX': lines['lineX'], 'lineY': lines['lineY'], 'strokeColor': arrows['bigLineColor'], 'lineWidth': arrows['bigLineWidth']}; // new design
			var workoutLineStructure2 = {'moveX': lines['moveX'], 'moveY': lines['moveY'], 'lineX': lines['lineX'], 'lineY': lines['lineY'], 'strokeColor': arrows['smallLineColor'], 'lineWidth': arrows['smallLineWidth']}; // new design
			this.elementDraw.mainLineDraw(this.ctx, workoutLineStructure);
			this.elementDraw.mainLineDraw(this.ctx, workoutLineStructure2);
			this.elementDraw.drawWorkoutArrows(this.id, this.ctx, lines['moveX'], lines['moveY'], lines['lineX'], lines['lineY'], arrowSide, arrows['arrowHeight'], arrows['arrowPos'], arrows['arrowGap']);
		}
		
	drawEllipse(x1, y1, x2, y2, color, lineW, innerFill, nostroke) {
		var radiusX = (x2 - x1) * 0.5,   /// radius for x based on input
			radiusY = (y2 - y1) * 0.5,   /// radius for y based on input
			centerX = x1 + radiusX,      /// calc center
			centerY = y1 + radiusY,
			step = 0.01,                 /// resolution of ellipse
			a = step,                    /// counter
			pi2 = Math.PI * 2 - step;    /// end angle
		
		this.ctx.beginPath();
		
		/// set start point at angle 0
		this.ctx.moveTo(centerX + radiusX * Math.cos(0),
				   centerY + radiusY * Math.sin(0));

		/// create the ellipse    
		for(; a < pi2; a += step) {
			this.ctx.lineTo(centerX + radiusX * Math.cos(a),
					   centerY + radiusY * Math.sin(a));
		}
		
		this.ctx.lineWidth = lineW;
		
		if( innerFill )
			{
				this.ctx.fillStyle = color;
				this.ctx.fill();
			}
		
		if ( !nostroke )
			{
				this.ctx.strokeStyle = color;
				this.ctx.stroke();
			}
			
		/// close it and stroke it for demo
		this.ctx.closePath();
		
		this.circleObj = {
			"x1" : x1,
			"y1" : y1,
			"x2" : x2,
			"y2" : y2,
			"t" : "c",
			"cl" : color,
			"rad" : radiusX,
			"lineW" : lineW
		};
	}
		
	gridSwitch(dochange, newgrid, gridcolor) {
		
		if ( dochange === true ) 
			{ 
				this.gridOn = newgrid; 
			} 
		else 
			{ 
				this.gridOn = !this.gridOn; 
			} 
		
		if ( this.gridOn )
			{
				if ( this.guestUser || this.hostVirtual ) 
					{  
						if ( this.$Any('#gridCanvas').length < 1 ) 
							{ 
								this.$('<canvas class="canvasGrid" id="gridCanvas" width="1280" height="720"></canvas>').insertAfter('#sessionCanvas'); 
							}
						
						this.gridCanvas = document.getElementById('gridCanvas');
						this.ctx2 = this.gridCanvas.getContext("2d");
					}
				else
					{
						if ( this.$Any('#gridCanvas'+this.id).length < 1 ) { this.$('<canvas class="canvasGrid" id="gridCanvas'+this.id+'" width="1280" height="720"></canvas>').insertAfter('#sessionCanvas'+this.id); }
						
						this.gridCanvas = this.$Any('#gridCanvas'+this.id)[0];
						this.ctx2 = this.gridCanvas.getContext("2d");
					}
				
				this.gridColor = gridcolor ? gridcolor : this.strokeColor;
				this.drawBoard();
			}
		else
			{
				this.ctx2.clearRect(0, 0, this.canvas.width, this.canvas.height); //clear canvas
				
				if ( this.guestUser || this.hostVirtual ) 
					{  
						this.$Any('#gridCanvas').remove();
					}
				else
					{
						this.$Any('#gridCanvas'+this.id).remove();
					}
						
				this.gridCanvas = false;
				this.ctx2 = false;
			}
		
		if ( !this.guestUser && window['allPartDetails'][this.id] )
			{
				var canvasSize = {};
				canvasSize['w'] = this.canvas.width;
				canvasSize['h'] = this.canvas.height;
				
				this.splitRTMSend(window['allPartDetails'][this.id]['email'], 'draw'+this.sep+JSON.stringify(this.canvasLines)+'cSize'+JSON.stringify(canvasSize));
				if ( !window['highlightActive'] || ( window['highlightActive'] && window['highlightUserId'] == this.id ) ) { 
					console.log('gridSwith sendRTM 1');
				window['globalRTM'](window['allPartDetails'][this.id]['email'], 'grid'+this.sep+(window['gridOn'+this.id] ? 1 : 0 )+this.sep+this.gridColor); }
				
				if ( window['highlightActive'] && window['highlightUserId'] == this.id )
					{
						 this.$Any('.participantStreamPart').each(function(item, index){
						  let parIdMain = this.$(this).attr('id').split('participant_agora');
						  let parId = parseInt(parIdMain[1]);
						  if ( parId != window.currentUserData['id'] && parId != this.id )
							{
								console.log('gridSwith sendRTM 2');
								window['globalRTM'](window['allPartDetails'][parId]['email'], 'grid'+this.sep+(window['gridOn'+this.id] ? 1 : 0 )+this.sep+this.gridColor);
							}
						 });
					}
			}
	}

	drawImage()
		{
			this.pauseDrawing = true;
			this.draw0 = false;
			this.stopClear = true;
			
			this.bagToolTip.innerHTML = 'Converting video to picture...';
			this.bagToolTip.classList.remove('d-none');
			
			if ( !this.guestUser && !this.hostVirtual )
				{
					window.$Any('#sessionCanvas'+this.id).addClass('agora_remove_pointer');
				}
			
			var videoElement = this.getVideoElement();
			
			this.ctx3.clearRect(0, 0, this.canvas.width, this.canvas.height);
			
			window['userIdForImage'] = this.id;
			
			if ( videoElement )
				{
					if ( videoElement.videoHeight )
						{
							this.ctx3.drawImage(videoElement, 0, (this.imageCanvas.height-videoElement.videoHeight * (this.imageCanvas.width/videoElement.videoWidth))/2, this.imageCanvas.width, videoElement.videoHeight * (this.imageCanvas.width/videoElement.videoWidth));
						}
					else 
						{
							this.drawCanvasFromVideoElement(videoElement);
						}
			
					this.savedData = new Image();
					this.savedData.src = this.imageCanvas.toDataURL("image/png");
					let mainthis = this;
					setTimeout(function() {
						mainthis.ctx.drawImage(mainthis.savedData,0,0);
						mainthis.drawLines();
						
						var circleNum = 0;
						mainthis.canvasLines.forEach(function(item, index) {
							var circleX, circleY;
							
							if ( item.stPoint )
								{
									circleX = item.stPoint.x;
									circleY = item.stPoint.y;
									
									circleNum++;
								}
							else if ( item.startX )
								{
									circleX = item.startX;
									circleY = item.startY;
									
									if ( item.t == 'cone' )
										{
											circleX = circleX + 10;
											circleY = circleY + 10;
										}
									else if ( item.t == 'cone_diagonal' )
										{
											circleX = circleX + 10;
											circleY = circleY + 10;
										}
										
									circleNum++;
								}
							else if ( item.x1 )
								{
									circleX = item.x1 + 10;
									circleY = item.y1 + 10;
									
									circleNum++;
								}
							else if ( Array.isArray(item) )
								{
									item.forEach(function(item2, index2) {
										if ( index2 > 0 )
											{
												if ( item2['x1'] )
													{
														circleX = item2.x1;
														circleY = item2.y1;
													}
												
												if ( item2['x'] )
													{
														circleX = item2.x;
														circleY = item2.y;
													}
											}
									});
									
									circleNum++;
								}
							
							mainthis.ctx.beginPath();
							mainthis.ctx.arc(circleX - 20, circleY - 20, 16, 0, 2 * Math.PI);
							mainthis.ctx.font = '16px Arial';
							mainthis.ctx.fillStyle = '#9b51e0';
							mainthis.ctx.fill();
							var textStructure = {'text': circleNum, 'startX': circleX - 20 - 4, 'startY': circleY - 20 + 5, 'font': '16px Arial', 'strokeColor': false, 'fillStyle': '#fff', 'lineWidth': 4};
							mainthis.elementDraw.writeText(mainthis.ctx, textStructure);
						});
						
						if ( this.gridOn )
							{
								this.gridData = new Image();
								this.gridData.src = this.gridCanvas.toDataURL("image/png");
								
								setTimeout(function() {
									mainthis.ctx.drawImage(mainthis.gridData,0,0); 
									mainthis.savedData2 = new Image();
									mainthis.savedData2.src = mainthis.canvas.toDataURL("image/png"); 
									window['canvasScreenshot'] = mainthis.savedData2.src;
									
									window.$('#screenshotPreviewImg').attr('src', window['canvasScreenshot']);
									
									window['showNotePopup'](mainthis.id);
									if ( !mainthis.guestUser && !mainthis.hostVirtual )
										{
											window.$Any('#sessionCanvas'+mainthis.id).removeClass('agora_remove_pointer');
										}
									mainthis.draw0 = true;
									mainthis.pauseDrawing = false;
								}, 2000);
							}
						else 
							{
								setTimeout(function() {
									mainthis.savedData2 = new Image();
									mainthis.savedData2.src = mainthis.canvas.toDataURL("image/png");
									window['canvasScreenshot'] = mainthis.savedData2.src;
									
									window.$Any('#screenshotPreviewImg').attr('src', window['canvasScreenshot']);
									
									window['showNotePopup'](mainthis.id);
									if ( !mainthis.guestUser && !mainthis.hostVirtual )
										{
											window.$Any('#sessionCanvas'+mainthis.id).removeClass('agora_remove_pointer');
										}
									mainthis.draw0 = true;
									mainthis.stopClear = false;
									mainthis.pauseDrawing = false;
								}, 1000);
							}
					}, 1000);
				}
		}
		
	resetImageCanvas() {
		this.ctx3.clearRect(0, 0, this.imageCanvas.width, this.imageCanvas.height);
		this.ctx.clearRect(0, 0, this.imageCanvas.width, this.imageCanvas.height);
		this.drawLines();
		this.stopClear = false;
	}
	
	activityStarted(activityName)
		{
			console.log('activityStarted activityName');
			console.log(activityName);
			var actId = this.getActivityId(activityName);
			console.log('activityStarted actId');
			console.log(actId);
			if ( actId && this.roomSetup.workoutAreaSetupDone )
				{
					this.hasDrawnMultipleTimes = 0;
					this.hasDrawnMultipleTimesVirtual = actId;
					
					console.log(this.hostVirtualOnMember, 'activityStarted 111');
					if ( !this.hostVirtualOnMember ) { this.resetActivityObject(); }
					console.log('activityStarted 222');
					this.globalActType = actId;
					console.log('activityStarted 333');
					this.globalEquipmentObject['currentActivity'] = actId;
					console.log('activityStarted 444');
					//this.trackerActions.setDetectors();
					window.changeGlobalActType(actId, parseInt(this.id));
					this.doActivityEvents('activityBeforeStart');
					console.log('activityStarted 555');
					this.setStatsIcons();
					console.log('activityStarted 666');
					//this.mouseActions.paletteClearClick();
					this.canvasLines = [];
					console.log('activityStarted 777');
					//if ( !this.guestUser ) { this.startVirtualActivity(actId); }
					console.log('activityStarted 888');
				}
		} 
	
	getActivityId(activityName)
		{
			if ( !activityName ) { return ''; }
			this.activityName = activityName;
			var mainthis = this;
			var activityId = '';
			var actObject = this.activityBuilderContent.activityBuilderObject;
			Object.keys(actObject).forEach(function(item, i)
				{
					let currentAct =  mainthis.activityBuilderContent.activityBuilderObject[item];
					if ( currentAct['activityName'] == activityName ) { activityId = item; }
				});
				
			return activityId;
		}
		
	startVirtualActivity(activityId)
		{
			var mainthis = this;

			window['scriptType'] = this.globalEquipmentObject[activityId]['scriptType'];
			window['repCounting'] = 0;
			window['missRepCounting'] = 0;
			this.$Any('#repCount'+this.id).html('0');
			this.$Any('#repCount'+this.id).removeClass('d-none');
			this.$Any('#ppmCount'+this.id+' .counter-number').html(0);
			this.$Any('#ppmCount'+this.id).removeClass('d-none');
			
			this.$Any('.paletteHolder').addClass("d-none");
			this.$Any('#repCountImage'+this.id).attr('class', this.globalEquipmentObject[activityId]['repCounterClass']);
			this.$Any('#perCountImage'+this.id).attr('class', this.globalEquipmentObject[activityId]['perCounterClass']);
			this.$Any('#repCountImage'+this.id).removeClass("squat_icon");
			this.$Any('#secondStats').removeClass("d-none");
			
			this.$Any('#movedEquipment'+this.id).removeClass('d-none');
			this.$Any('#inZoneStatus'+this.id).addClass('d-none');
			
			this.$Any('#successMarkPar'+this.id).addClass('d-none');
			this.$Any('#setupEquipmentHold'+this.id).addClass('whiteBkg');
			this.$Any('#movedEquipment'+this.id).addClass('smallerButton').html('Edit');
			this.$Any('.equipmentSetupText').removeClass('d-none');
			this.$Any('.equipment_stats_hold').removeClass('d-none');
			
			let playAudioSetup = this.globalEquipmentObject[activityId]['bothSetupAudio'];;
			if ( this.currentUserData.allowPartMove == 0 ) { playAudioSetup = this.globalEquipmentObject[activityId]['hostSetupAudio']; } //script_name == 'Lateral Cone Touch' ? 'coneHostSetup' : script_name == 'Boxing Bag 1' ? 'boxingHostSetup' : 'squatHostSetup';
			this.soundPlay.stopAudio(playAudioSetup);
			this.mouseActions.paletteClearClick();
			
			this.splitRTMSend(window['allPartDetails'][this.id]['email'], 'hostStartedEquipment'+this.sep);

			if ( this.currentUserData.sessionData.manualAutomaticScript == 1 && !this.activityAlreadyStarted )
				{
					this.$Any('#setupEquipmentHold'+this.id).addClass('d-none');
					this.activityAlreadyStarted = true;

					setTimeout(function() {
						mainthis.$('#actStart').trigger('click');
					}, 2000);
				}
			else if ( this.currentUserData.sessionData.manualAutomaticScript != 1 )
				{
					//this.$Any('#setupEquipmentHold'+this.id).removeClass('d-none');
					this.$('#actStart').removeClass('d-none');
				}
		}
		
	drawArrows()
		{
			if ( !this.globalActType || ( this.globalActType && this.globalActType != 'workoutAreaSetup' && !this.roomSetup.workoutAreaSetupDone ) ) { return false; }
			var mainthis = this;
			var currentActivity = this.activityBuilderContent.activityBuilderObject[this.globalActType];
			var globalObject = this.getCurrentObject();
			currentActivity.drawArrows.forEach(function(actArrows, index) {
				var arrowOutsideLine = false;
				var arrowInsideLine = false;
				var showArrows = true;
				
				if ( actArrows['displayCondition'] && actArrows['displayCondition'][0] && globalObject['customVariables'] )
					{
						if ( globalObject['customVariables'][actArrows['displayCondition'][0]] !== actArrows['displayCondition'][1] )
							{
								showArrows = false;
							}
					}
				if ( actArrows['connectType'] == 'objects' && actArrows['objects'].length == 2 )
					{
						var imageObject1 = mainthis.getImageObject(mainthis.activityBuilderContent.activityBuilderObject[mainthis.globalActType]['drawingObjects'][actArrows['objects'][0]], false);
						var imageObject2 = mainthis.getImageObject(mainthis.activityBuilderContent.activityBuilderObject[mainthis.globalActType]['drawingObjects'][actArrows['objects'][1]], false);
						
						arrowOutsideLine = {'moveX': imageObject1['centerX'], 'moveY': imageObject1['centerY'], 'lineX': imageObject2['centerX'], 'lineY': imageObject2['centerY'], 'strokeColor': actArrows['style']['outsideLineColor'], 'lineWidth': actArrows['style']['outsideLineSize']};
						arrowInsideLine = {'moveX': imageObject1['centerX'], 'moveY': imageObject1['centerY'], 'lineX': imageObject2['centerX'], 'lineY': imageObject2['centerY'], 'strokeColor': actArrows['style']['middleLineColor'], 'lineWidth': actArrows['style']['middleLineSize']};
					}
				if ( actArrows['connectType'] == 'activeZones' && actArrows['zones'].length == 2 )
					{
						var imageObject1 = mainthis.getActiveZone(actArrows['zones'][0]);
						var imageObject2 = mainthis.getActiveZone(actArrows['zones'][1]);
						
						arrowOutsideLine = {'moveX': imageObject1['centerX'], 'moveY': imageObject1['centerY'], 'lineX': imageObject2['centerX'], 'lineY': imageObject2['centerY'], 'strokeColor': actArrows['style']['outsideLineColor'], 'lineWidth': actArrows['style']['outsideLineSize']};
						arrowInsideLine = {'moveX': imageObject1['centerX'], 'moveY': imageObject1['centerY'], 'lineX': imageObject2['centerX'], 'lineY': imageObject2['centerY'], 'strokeColor': actArrows['style']['middleLineColor'], 'lineWidth': actArrows['style']['middleLineSize']};
					}
				if ( arrowOutsideLine && arrowInsideLine && showArrows )
					{
						var direction = imageObject1['centerX'] < imageObject2['centerX'] ? 'left': 'right';
						mainthis.elementDraw.mainLineDraw(mainthis.ctx, arrowOutsideLine);
						mainthis.elementDraw.mainLineDraw(mainthis.ctx, arrowInsideLine);
						mainthis.elementDraw.drawWorkoutArrows(mainthis.id, mainthis.ctx, imageObject1['centerX'], imageObject1['centerY'], imageObject2['centerX'], imageObject2['centerY'], direction, actArrows['style']['arrowHeight'], actArrows['style']['arrowPos'], actArrows['style']['arrowGap']);
					}
			});
		}
		
	drawActiveZones(item, imageObject)
		{
			if ( !item['activeZone'] || item['activeZone'].length == 0 ) { return false; }
			var currentActivityObject = this.getCurrentObject();
			var mainthis = this;
			var activeZones = item['activeZone'];
			activeZones.forEach(function(zone, i) {
				var zoneX1 = 0;
				var zoneX2 = 0;
				var zoneY1 = 0;
				var zoneY2 = 0;
				
				//console.log(mainthis.trackerActions.trackerStandInZone, mainthis.activeZoneSet, i, mainthis.currentZoneSet, 'currentZoneSet');
				//if ( i != mainthis.currentZoneSet && !mainthis.trackerActions.trackerStandInZone ) { mainthis.activeZoneSet = false; }
				if ( ( window['forceAllow'] || mainthis.trackerActions.trackerStandInZone ) && mainthis.activeZoneSet && i == mainthis.currentZoneSet ) { window['forceAllow'] = false; console.log('currentZoneSet called'); mainthis.callActiveZoneAction(zone); console.log('currentZoneSet after');}
				
				if ( zone['relativeTo'] == 'image' )
					{
						// calculate zone X1
						zoneX1 = mainthis.trackerActions.calculatePosition(zone['x1'], imageObject, imageObject['x']);
						
						// calculate zone X2
						zoneX2 = mainthis.trackerActions.calculatePosition(zone['x2'], imageObject, imageObject['x']);
						
						// calculate zone Y1
						zoneY1 = mainthis.trackerActions.calculatePosition(zone['y1'], imageObject, imageObject['y']);
						
						// calculate zone Y2
						zoneY2 = mainthis.trackerActions.calculatePosition(zone['y2'], imageObject, imageObject['y']);
					}
					
				if ( zone['relativeTo'] == 'grid' )
					{
						var zonePosition = mainthis.getActiveZone(zone);
						
						zoneX1 = zonePosition['x'];
						zoneX2 = zonePosition['x'] + zonePosition['w'];
						zoneY1 = zonePosition['y'];
						zoneY2 = zonePosition['y'] + zonePosition['h'];
					}
					
				if ( zone['zoneType'] == 'animatedCircle' && !zone['isHidden'] )
					{
						var zonePoints = {'leftSideOfSpace': zoneX1, 'rightSideOfSpace': zoneX2, 'topSide':  zoneY1, 'bottomSide': zoneY2};
						var inZone = false;
						
						if ( ( mainthis.guestUser || mainthis.onDemand ) && !mainthis.activeZoneSet && i == mainthis.currentZoneSet )
							{
								var circleObject = {'lowestpointX': mainthis.trackerActions.lowest_pointX, 'leftSideOfSpace': zoneX1, 'rightSideOfSpace':zoneX2, 'lowest_point': mainthis.trackerActions.lowest_point, 'topSide': zoneY1, 'bottomSide': zoneY2};
								mainthis.trackerActions.setTrackerZoneAndRegion(circleObject, mainthis.trackerRegion);
								mainthis.activeZoneSet = true;
							}
						
						if ( mainthis.trackerActions.trackerStandInZone && zone['zoneTypeInside'] == 'emptyCircle' ) { inZone = true; }
						mainthis.elementDraw.targetCircle(mainthis.id, mainthis.ctx, zonePoints, inZone, true);
					}
				
				if ( zone['zoneType'] == 'emptyCircle' && !zone['isHidden'] )
					{
						var zonePoints = {'leftSideOfSpace': zoneX1, 'rightSideOfSpace': zoneX2, 'topSide':  zoneY1, 'bottomSide': zoneY2};
						var inZone = false;
						var greenCircle = false;
						
						if ( ( mainthis.guestUser || mainthis.onDemand ) && !mainthis.activeZoneSet && i == mainthis.currentZoneSet )
							{
								var circleObject = {'lowestpointX': mainthis.trackerActions.lowest_pointX, 'leftSideOfSpace': zoneX1, 'rightSideOfSpace':zoneX2, 'lowest_point': mainthis.trackerActions.lowest_point, 'topSide': zoneY1, 'bottomSide': zoneY2};
								mainthis.trackerActions.setTrackerZoneAndRegion(circleObject, mainthis.trackerRegion);
								mainthis.activeZoneSet = true;
							}
						if ( mainthis.trackerActions.trackerStandInZone ) { greenCircle = zone['zoneTypeInside']; }
						mainthis.elementDraw.targetCircle(mainthis.id, mainthis.ctx, zonePoints, true, true, greenCircle);
					}
					
				if ( zone['zoneType'] == 'staticCircle' )
					{
						mainthis.elementDraw.staticCircle(mainthis.ctx, zoneX1, zoneX2, zoneY1, zoneY2);
					}
			});
		}
		
	getCurrentObject()
		{
			if ( this.activityBuilderContent &&
				this.globalActType &&
				this.activityBuilderContent.activityBuilderObject[this.globalActType] )
					{
						return this.activityBuilderContent.activityBuilderObject[this.globalActType];
					}
				
			return false;
		}
	
	changeGlobalCounter = (mod, value) =>
		{
			if ( this.onDemand && this.memberNoHostVirtual && !window.pauseVirtualActivityStarted && mod != 'reset' ) { return false; }
			
			var sendValue = value;
			if ( mod == 'positive' ) { this.globalCounter = parseInt(this.globalCounter) + parseInt(value); sendValue = parseInt(this.globalCounter); }
			else if ( mod == 'negative' ) { this.globalNegativeCounter = this.globalNegativeCounter + parseInt(value); sendValue = this.globalNegativeCounter; }
			else if ( mod == 'reset' ) 
				{ 
					this.globalCounter = 0;
					this.globalPerMinuteCounter = 0;
					this.globalNegativeCounter = 0;
					sendValue = 0;
					
					//this.$('#perMinuteCounter').html(this.globalNegativeCounter);
					if ( !this.guestUser && !this.hostVirtual )
						{
							this.$Any('#ppmCount'+this.id+' .counter-number').html(this.globalNegativeCounter);
						}
				}
			
			if ( (this.guestUser && !this.hostVirtualOnMember) || this.hostVirtual || (this.onDemand && !this.memberNoHostVirtual) )
				{
					this.$('#repcounter').html(this.globalCounter);
					this.counterAll = this.counterAll + parseInt(value);
					window['counterAll'] = this.counterAll;
					/*if ( this.$('#score'+this.id) ) 
						{ 
							var userCounter = parseInt(this.$("#score"+this.id).html()) + parseInt(value);
							this.$("#score"+this.id).html(this.counterAll);
						}*/
				}
			
			if ( (this.hostVirtualOnMember || (this.onDemand && this.memberNoHostVirtual)) && window.pauseVirtualActivityStarted && ( mod == 'positive' || mod == 'reset' ) )
				{
					this.globalCounter = value;
					this.$('#repcounter').html(value);
				}
			
			if ( !this.guestUser && !this.hostVirtual && !this.onDemand && ( mod == 'positive' || mod == 'reset' ) )
				{
					this.globalCounter = value;
					this.$Any('#repCount'+this.id).html(value);
				}
			
			if ( mod == 'negative' )
				{
					if ( (this.guestUser && !this.hostVirtualOnMember) || this.hostVirtual || (this.onDemand && !this.memberNoHostVirtual) )
						{
							this.$('#perMinuteCounter').html(this.globalPerMinuteCounter);
							this.$('#repCounterNegative').html('/ '+this.globalNegativeCounter);
							this.$Any('#repCountNegHost').html('/'+this.globalNegativeCounter);
						}
					
					if ( (this.hostVirtualOnMember || (this.onDemand && this.memberNoHostVirtual)) && window.pauseVirtualActivityStarted )
						{	
							this.globalNegativeCounter = value;
							this.$('#perMinuteCounter').html(this.globalPerMinuteCounter);
							this.$('#repCounterNegative').html('/ '+this.globalNegativeCounter);
						}
					
					if ( !this.guestUser && !this.hostVirtual )
						{
							this.globalNegativeCounter = value;
							this.$Any('#ppmCount'+this.id+' .counter-number').html(value);
						}
				}
				
			if ( (this.guestUser && !this.hostVirtualOnMember) || this.hostVirtual )
				{
					var message = 'changeGlobalCounter'+this.sep+mod+this.sep+sendValue+this.sep+value;
					//this.splitRTMSend(this.currentUserData.sessionData.hostEmail, message);
					this.sendMemberCounter = message;
					//window['sendMessageToChannel'](message);
				}
			
			console.log(value, 'changeGlobalCounter value', this.id);
			console.log(this.globalCounter, 'changeGlobalCounter globalCounter', this.id);
		}
	
	setStatsIcons() 
		{
			if ( !this.globalActType || !this.activityBuilderContent || !this.activityBuilderContent.activityBuilderObject[this.globalActType] || !this.activityBuilderContent.activityBuilderObject[this.globalActType]['statistics'] || !this.activityBuilderContent.activityBuilderObject[this.globalActType]['statistics'][1] ) { return false; }
			var currentActivityObject = this.getCurrentObject();
			
			this.$Any('.equipment_stats_hold').removeClass("d-none");
			this.$Any('#virtualPunchHold').removeClass("d-none");
			this.$Any('#virtualPunchMinuteHold').removeClass("d-none");
			this.$Any('#repCount'+this.id).removeClass("d-none");
			this.$Any('#ppmCount'+this.id).removeClass("d-none");
			this.$Any('#repcounter').removeClass("d-none");
			this.$Any('#repCountNegHost').removeClass("d-none");
			this.$Any('#perMinuteCounter').removeClass("d-none");
			
			this.$Any('#repCountImagePar').css('background-image', 'url('+currentActivityObject['statistics'][0]['src']+')');
			this.$Any('#repCountImage'+this.id).css('background-image', 'url('+currentActivityObject['statistics'][0]['src']+')');
			this.$Any('#perCountImagePar').css('background-image', 'url('+currentActivityObject['statistics'][1]['src']+')');
			this.$Any('#perCountImage'+this.id).css('background-image', 'url('+currentActivityObject['statistics'][1]['src']+')');
			
			this.$Any('#nameOfCounter').html(currentActivityObject['statistics'][1]['counterName']);
			this.$Any('#pmName'+this.id).html(currentActivityObject['statistics'][1]['counterName']);
			
			this.$Any('#repCountImagePar').attr('data-count', currentActivityObject['statistics'][0]['name']);
			this.$Any('#perCountImagePar').attr('data-count', currentActivityObject['statistics'][1]['name']);
			this.$Any('#secondStatsPar').removeClass("d-none");
			
			if ( this.onDemand ) { this.$Any('.on_demand_stats').removeClass("d-none"); }
		}
		
	calculatePerMinuteCounter = () =>
		{
			if ( !this.globalActType || !this.activityBuilderContent || !this.activityBuilderContent.activityBuilderObject[this.globalActType] || !this.activityBuilderContent.activityBuilderObject[this.globalActType]['statistics'] || !this.activityBuilderContent.activityBuilderObject[this.globalActType]['statistics'][1] || this.activityBuilderContent.activityBuilderObject[this.globalActType]['statistics'][1]['calc'] !== 'perMinute' ) { return false; }
			
			if ( this.$Any('#perCountImagePar').attr('data-count') == 'negative' ) { return false; }
			
			if ( !window.pauseVirtualActivityStarted && (this.hostVirtualOnMember || this.memberNoHostVirtual) ) { return false; }
			if ( window.pauseVirtualActivityStarted && !this.hostVirtualOnMember && !this.memberNoHostVirtual ) { return false; }
			
			var remainingTime = 0;
			var actIndex = 0;
			var counterElement;
			
			if ( this.guestUser )
				{
					actIndex = window['allIndexGlobal'];
					remainingTime = window['globalTimeTimer'];
					counterElement = this.$Any('#perMinuteCounter')[0];
				}
			else if ( !this.guestUser && !this.onDemand )
				{
					actIndex = window['currentActNum']-1;
					remainingTime = window['timeLefSec'];
					
					if ( this.hostVirtual )
						{
							counterElement = this.$Any('#perMinuteCounter')[0];
						}
					else
						{
							counterElement = this.$Any('#ppmCount'+this.id+' .counter-number')[0];
						}
				}
			else if ( this.onDemand )
				{
					let activeEle = window.$('.swiper-slide.swiper-slide-next');
					actIndex = activeEle.attr('data-index') - 1;
					remainingTime = parseInt(window.$('#activityCounter .counter-number').html());
					counterElement = this.$Any('#perMinuteCounter')[0];
				}
			if ( actIndex < 0 ) { actIndex = 0; }
			
			if ( this.currentUserData.sessionData.scriptDetail && !isNaN(actIndex) && this.currentUserData.sessionData.scriptDetail[actIndex] )
				{	
					var startTime = parseInt(this.currentUserData.sessionData.scriptDetail[actIndex]['attribute'][2]['attrValue']);
					var mainDiff = startTime - remainingTime;
					var diff = 60/mainDiff;
					
					var perMinuteCount = (this.globalCounter * diff).toFixed(0);
					if( !isNaN(parseFloat(perMinuteCount)) && perMinuteCount < 100000 && perMinuteCount >= 0 )
						{
							this.globalPerMinuteCounter = perMinuteCount;
							this.$(counterElement).html(this.globalPerMinuteCounter);
						}
				}
		}
		
	doActivityEvents(ev, mess)
		{
			var currentActivityObject = this.getCurrentObject();
			if ( !this.globalActType || !this.activityBuilderContent || !this.activityBuilderContent.activityBuilderObject[this.globalActType] || !this.roomSetup.workoutAreaSetupDone || !currentActivityObject['activityEvents'] ) { return false; }
			var mainthis = this;
			var actAudioPlay;
			var actStartDelay = currentActivityObject['startDelay'];
			var displayedMessage;
			
			window.doActivityEventsFlutter(ev, this.id);
			console.log('doActivityEvents', ev);

			if ( ev == 'activityStarting' ) 
				{
					setTimeout(function() {
						mainthis.doActivityEvents('activityStarted');
					}, actStartDelay);
				}
			else if ( ev == 'activityBeforeStart' )
				{
					mainthis.currentZoneSet = 0;
					mainthis.activeZoneSet = false;
					//mainthis.changeGridZone();
					if ( window.setDetectors ) { window.setDetectors(this.id); }
				}
			else if ( ev == 'activityStarted' )
				{
					this.$Any('#repCountNegHost').html('');
					if ( !this.onDemand )
						{
							let addObject = {"sessionId": this.currentUserData.sessionData.id,  "userId": this.currentUserData.id, "event": "status", "eventType": "virtualActivity", "details": JSON.stringify({"msg": "Started "+this.activityName+" Virtual Activity"}), "timestamp": this.Util.getCurrentTimestamp()};
							this.sessionDataStore.addSessionData(addObject);
						}
					setTimeout(function() {
						mainthis.clearMessageInstructions();
					}, actStartDelay);
					
					mainthis.currentPersonalBest();
					if ( this.currentUserData.default.rtmStartSend > 0 ) 
						{
							this.intervalSendCounter = setInterval(()=> {
								window['sendMessageToChannel'](this.sendMemberCounter);
							}, 10000);
						}
				}
			else if ( ev == 'activityEnded' )
				{
					console.log('activityEnded----');
					this.$('.personal_b_ppm').html('0 reps per minute');
					this.$('#myPersBest').html('0');
					this.$('#repCounterNegative').html('');
					this.$Any('#repCountNegHost').html('');
					this.personalBest = 0;
					this.counterPersBest = 0;
					if ( this.intervalSendCounter )
						{
							clearInterval(this.intervalSendCounter);
						}
					if ( mess == 'act_end' ) { mainthis.setActivityStatistic(); }
					if ( !this.onDemand )
						{
							let addObject = {"sessionId": this.currentUserData.sessionData.id,  "userId": this.currentUserData.id, "event": "status", "eventType": "virtualActivity", "details": JSON.stringify({"msg": "Ended "+this.activityName+" Virtual Activity. Punches count"+ this.globalCounter+""}), "timestamp": this.Util.getCurrentTimestamp()};
							this.sessionDataStore.addSessionData(addObject);
						}
				}
		}
	
	currentPersonalBest=()=> {
		var actIndex = window.currentIndex > -1 ? window.currentIndex : 0;
		var previousActivity = this.currentUserData.sessionData.scriptDetail[actIndex];

		if ( this.leaderboardValues )
			{
				console.log('this.leaderboardValues', this.leaderboardValues);
				for ( var i = 0; i < this.leaderboardValues.length; i++ )
					{
						//console.log('previousActivity123', previousActivity, this.leaderboardValues[i].activityName );
						if ( previousActivity['name'] == this.leaderboardValues[i].activityName )
							{
								//console.log('previousActivityTrue', previousActivity, this.leaderboardValues[i].activityName );
								if ( this.leaderboardValues[i].counterAverage > this.personalBest )
									{
										this.personalBest = this.leaderboardValues[i].counterAverage; 
									}
									
								if ( this.leaderboardValues[i].counter > this.counterPersBest )
									{
										this.counterPersBest = this.leaderboardValues[i].counter; 
									}
								//this.counterPersBest = this.leaderboardValues[i].counter;
							}
					}
			}
		console.log('personalBest', this.personalBest );
		console.log('counterPersBest', this.counterPersBest );
		this.$('.personal_b_ppm').html(this.personalBest+' reps per minute');
		this.$('#myPersBest').html(this.counterPersBest);
	}
	
	setActivityStatistic()
		{
			console.log('setActivityStatistic----');
			var axiosVirdio = new axiosVirdioT(this.props);
			var actIndex = window.currentIndex > -1 ? window.currentIndex : 0;
			var previousActivity = this.currentUserData.sessionData.scriptDetail[actIndex];
			var liveSession = 0;
			var ondemandSession = 0;
			var counterNegative = this.globalPerMinuteCounter;
			if ( this.currentUserData.sessionData.ondemandId > 0 ) 
				{
					liveSession = 0;
					ondemandSession = 1;
				}
			else 
				{
					liveSession = 1;
					ondemandSession = 0;
				}
				
			/*if ( this.globalNegativeCounter > 0 ) 
				{
					counterNegative = this.globalNegativeCounter;
				}
			else 
				{
					counterNegative = this.globalPerMinuteCounter; 
				}*/
			console.log('counterNegative----', counterNegative );
			console.log('globalCounter----', this.globalCounter );
			if ( previousActivity )
				{
					var statsObj = {
						'activityId': previousActivity['id'],
						'classId': this.currentUserData.sessionData.id,
						'userId': this.currentUserData.id,
						'activityName': previousActivity['name'],
						'duration': previousActivity['attribute'][2]['attrValue'],
						'counter': this.globalCounter,
						'counterAverage': counterNegative,
						'liveSession': liveSession,
						'ondemandSession': ondemandSession,
					};
					
					
					if ( this.currentUserData.leaderboardValues )
						{
							this.leaderboardValues = this.currentUserData.leaderboardValues;
						}
					
					this.leaderboardValues.push(statsObj);
					
					//this.currentUserData.leaderboardValues = this.leaderboardValues;
					this.currentUserData['leaderboardValues'] = this.leaderboardValues;
					console.log('----this.currentUserData', this.currentUserData);
					localStorage.setItem('userData', JSON.stringify(this.currentUserData));
					
					console.log('----newLeaderboard-----', this.leaderboardValues);
					
					this.savePersonalBest.push(statsObj);
					
					axiosVirdio.post(process.env.REACT_APP_API_URL+"/api/v1/session/insertLeaderboardValues",{values: JSON.stringify(statsObj)}).then(res => {
										
					}).catch(err =>{
						
						console.log('-error', err);
					});
				}
		}
	
	callActiveZoneAction(zone)
		{
			console.log('currentZoneSet innit');
			var mainthis = this;
			var detectActions = zone['detectAction'];
			var currentActivityObject = this.getCurrentObject();
			console.log(detectActions, 'detectActions');
			
			detectActions.forEach(function(item, index) {
				if ( item['action'] == 'removeZone' && !mainthis.ifZoneRemoved )
					{
						mainthis.ifZoneRemoved = true;
						let delay = item['delay'] ? item['delay'] : 0;
						setTimeout(function() {
							zone['isHidden'] = true;
						}, delay);
					}
				else if ( item['action'] == 'customVariable' )
					{
						mainthis.updateCustomVariable(item['name'], item['value']);
					}
				else if ( item['action'] == 'changeThis' )
					{
						zone[item['name']] = item['value'];
					}
				else if ( item['action'] == 'changeZone' )
					{
						var defaultAction = item['item'];
						if ( defaultAction == 'nextZone' )
							{
								defaultAction = currentActivityObject.customVariables['nextZone'];
							}
						var cIndex = 0;
						var zIndex = defaultAction;
						currentActivityObject.drawingObjects.forEach(function(itemZ, index) {
							if ( itemZ['activeZone'] )
								{
									itemZ['activeZone'].forEach(function(itemZ2, i) {
										if ( cIndex != mainthis.currentZoneSet )
											{
												itemZ2[item['name']] = 'staticCircle';
											}
										if ( cIndex == zIndex )
											{
												itemZ2[item['name']] = item['value'];
											}
										cIndex++;
									});
								}
						});
						mainthis.currentZoneSet = defaultAction;
						mainthis.activeZoneSet = false;
					}
				else if ( item['action'] == 'changeArrows' )
					{
						var defaultValues = [item['value'][0], item['value'][1]];
						if ( item['value'][0] && item['value'][0] == 'nextZone' )
							{
								defaultValues[0] = currentActivityObject.customVariables['nextZone'];
							}
						if (  item['value'][1] && item['value'][1] == 'nextZone' )
							{
								defaultValues[1] = currentActivityObject.customVariables['nextZone'];
							}
						currentActivityObject.drawArrows[0][item['name']] = defaultValues;
					}
				else if ( item['action'] == 'counter' )
					{
						mainthis.changeGlobalCounter(item['name'], item['value']);
						mainthis.calculatePerMinuteCounter();
					}
				else if ( item['action'] == 'audio' )
					{
						var actAudioPlay = currentActivityObject['audio'][item['name']];
						mainthis.soundPlay.playAudio(actAudioPlay);
					}
			});
		}
	
	updateCustomVariable(name, val)
		{
			if ( !this.globalActType || !this.activityBuilderContent || !this.activityBuilderContent.activityBuilderObject[this.globalActType] ) { return false; }
			
			var currentActivityObject = this.getCurrentObject();
			currentActivityObject.customVariables[name] = val;
		}
		
	changeGridZone()
		{
			if ( ( !this.globalActType || ( this.globalActType && this.globalActType == 'workoutAreaSetup' ) ) || !this.activityBuilderContent || !this.activityBuilderContent.activityBuilderObject[this.globalActType] ) { return false; }
			
			var currentActivityObject = this.getCurrentObject();
			this.gridActions.setGridZone(this.roomSetup.workoutConeLocation['topRight']['posX'], this.roomSetup.workoutConeLocation['topLeft']['posX'], this.roomSetup.workoutConeLocation['bottomRight']['posX'], this.roomSetup.workoutConeLocation['bottomLeft']['posX'], this.roomSetup.workoutConeLocation['topLeft']['posY'], this.roomSetup.workoutConeLocation['bottomRight']['posY'], currentActivityObject['gridColumns'], currentActivityObject['gridRows'], false);
		}
		
	dartTest(str)
		{
			console.log('dartTest called:', str);
		}
	
	findVariantsElement = (main, compareWith) => {
	  var result = {};
	  var mainthis = this;
	  Object.keys(main).map((r) => {
		var element = main[r];
		if ( compareWith[r] != undefined  && compareWith[r] != null ) {
		  if (JSON.stringify(element) != JSON.stringify(compareWith[r])) {
			  if ( typeof compareWith[r] === 'object' && compareWith[r] !== null )
				  {
					 var rtmGet = mainthis.findVariantsElement(element, compareWith[r]);
					 if ( !this.$.isEmptyObject(rtmGet) )
						 {
							 result[r] = rtmGet;
						 }
				  }
			  else
				  {
					result[r] = compareWith[r];
				  }
		  }
		}
	  });
	  return result;
	}
	
	changeGlobalObject = (object, actName, userId) =>
		{
			if ( this.onDemand && this.memberNoHostVirtual && !window.pauseVirtualActivityStarted ) { return false; }
			
			var objectGlobal = JSON.parse(object);
			/* console.log('changeGlobalObject actName');
			console.log(actName); */
			
			if ( actName == 'reset' || actName == '' )
				{
					this.activityBuilderContent.activityBuilderObject = objectGlobal;
				}
			else
				{
					this.activityBuilderContent.activityBuilderObject[actName] = objectGlobal;
				}
				
			/* console.log('changeGlobalObject activityBuilderObject');
			console.log(this.activityBuilderContent.activityBuilderObject); */
			
			var sendId = this.id;
			if ( userId ) { sendId = userId; }
			
			window.modifyGlobalObject(JSON.stringify(this.activityBuilderContent.activityBuilderObject), parseInt(sendId));
			
			if ( ((this.guestUser && !this.hostVirtualOnMember) || this.hostVirtual) && actName != 'reset' )
				{
					var sendObj = (actName == 'reset' || actName == '') ? this.activityBuilderContent.activityBuilderObject : this.activityBuilderContent.activityBuilderObject[actName];
					var sendObjText = JSON.stringify(sendObj);
					
					if ( !this.previousObjectRTM[actName] || this.previousObjectRTM[actName] != sendObjText )
						{
							//console.log(this.previousObjectRTM[actName], 'object_change prev value');
							//console.log(sendObjText, 'object_change newValue');
							var sendInfo = sendObj;
							if ( this.previousObjectRTM2[actName] )
								{
									var c = this.findVariantsElement(this.previousObjectRTM2[actName], sendObj);
									sendInfo = c;
									//console.log(c, 'difference_compiler DEFINITION'); 
								}
							
							this.previousObjectRTM[actName] = sendObjText;
							this.previousObjectRTM2[actName] = sendObj;
							
							var message = 'modifyGlobalObject'+this.sep+JSON.stringify(sendInfo)+this.sep+actName;
							this.splitRTMSend(this.currentUserData.sessionData.hostEmail, message);
							this.objectChanges = [];
						}
				}
		}
		
	changeGlobalObjectRTM = (object, actName) =>
		{
			if ( this.onDemand && this.memberNoHostVirtual && !window.pauseVirtualActivityStarted ) { return false; }
			
			var updatedActivityObject = window.modifyGlobalObjectRTM(object, parseInt(this.id), actName);
			
			if ( !this.$.isEmptyObject(JSON.parse(updatedActivityObject)) ) { this.activityBuilderContent.activityBuilderObject = JSON.parse(updatedActivityObject); }
		}

	addFlutterWhiteboard = () =>
		{
			console.log('addFlutterWhiteboard ', this.currentUserData.id);
			var newUserData = {'id': this.id, 'userType': this.currentUserData.userType, 'onDemand': this.onDemand, 'whiteboardValues': this.currentUserData.whiteboardValues};
			
			var workoutZone = {};
			
			var windowResolution = {
				'w': window.innerWidth, 
				'h': window.innerHeight
			};
			
			var sameResolution = true;
			if ( window['workoutConePlacing'+this.id] && 
				( !window['workoutConePlacing'+this.id]['canvasSize'] || 
				( window['workoutConePlacing'+this.id]['canvasSize'] && (window['workoutConePlacing'+this.id]['canvasSize']['w'] != windowResolution['w'] || window['workoutConePlacing'+this.id]['canvasSize']['h'] != windowResolution['h']) ) ) )
				{
					sameResolution = false;
				}
			
			if ( window['workoutConePlacing'+this.id] && window['workoutConePlacing'+this.id]['topRight'] && window['workoutConePlacing'+this.id]['topRight']['posX'] && sameResolution )
				{
					workoutZone = {
						'x1': parseInt(window['workoutConePlacing'+this.id]['topRight']['posX']),
						'x2': parseInt(window['workoutConePlacing'+this.id]['topLeft']['posX']),
						'x3': parseInt(window['workoutConePlacing'+this.id]['bottomRight']['posX']),
						'x4': parseInt(window['workoutConePlacing'+this.id]['bottomLeft']['posX']),
						'y1': parseInt(window['workoutConePlacing'+this.id]['topRight']['posY']),
						'y2': parseInt(window['workoutConePlacing'+this.id]['bottomRight']['posY']),
						'columns': 5,
						'rows': 3
					};
				}
			console.log(JSON.stringify(workoutZone));
			window.addUserWhiteboard(JSON.stringify(this.activityBuilderContent.activityBuilderObject), JSON.stringify(newUserData), this.hostVirtual, this.hostVirtualOnMember, this.memberNoHostVirtual, this.onDemand, JSON.stringify(workoutZone), window['hasBoxing']);
			console.log('addFlutterWhiteboard after ', this.currentUserData.id);
		}
		
	sendRTMFlutter = (fileName, varName, varValue) =>
		{
			console.log('sendRTMFlutter called ', fileName, varName, varValue);
			
			if ( this.guestUser || this.hostVirtual )
				{
					var message = 'modifyCustomVariable'+this.sep+JSON.stringify([fileName, varName, varValue]);
					this.splitRTMSend(this.currentUserData.sessionData.hostEmail, message);
			console.log('sendRTMFlutter send RTM');
				}
		}
		
	resetActivityObject = () =>
		{
			this.activityBuilderContent = new activityBuilderContent(this.whiteboardValues['activityBuilderObject']);
			this.changeGlobalObject(JSON.stringify(this.activityBuilderContent.activityBuilderObject), 'reset');
		}
		
	redoRoomSetup = () => 
		{
			console.log('redoRoomSetup');
			this.roomSetup.workoutAreaSetupDone = false;
			this.roomSetup.mediaCircleCompleted = false;
			//window['mediaPipeFirstTime'] = false;
			this.resetActivityObject();
			//window['resetRoomSetup']();
		}
		
	getImageDimensions = () =>
		{
			if ( !window['boxJumpWidth'] || !window['boxJumpHeight'] ) 
				{ 
					window['boxJumpHeight'] = 98; 
					window['boxJumpWidth'] = 98;  
				}
				
			return {'w': window['boxJumpWidth'], 'h': window['boxJumpHeight'] }
		}
		
	getBoxingCirclePosition = () =>
		{
			if ( isNaN(window['boxingCirclePosition']) )
				{
					window['boxingCirclePosition'] = 1;
				}
				
			return window['boxingCirclePosition'];
		}

	updateGridZone = (gridZoneObj) =>
		{
			this.splitRTMSend(this.currentUserData['sessionData']['hostEmail'], "updateGridZone"+this.sep+gridZoneObj);
		}
	
	updateBagPositionCall = () =>
		{
			if ( window['updateBagPosition'] ) 
				{
					window['updateBagPosition'](this.currentUserData.id, window['bagPosition']); 
				}
		}
	
	getRoomInstructions = () =>
		{
			return window['roomSetupAudioInstructions'];
		}
		
	setTopAndBottomLine = (topLine, bottomLine, topLineCorrect, bottomLineCorrect) =>
		{
			this.$('.top_room_setup_bar').removeClass('d-none');
			this.$('.bottom_room_setup_bar').removeClass('d-none');
			
			if ( topLineCorrect )
				{
					this.$('.top_room_setup_bar').attr('style', 'background-color: #1aff2382; background-image: url("./images/room_correct.svg"); height: '+topLine+'px');
				}
			else
				{
					this.$('.top_room_setup_bar').attr('style', 'background-color: #ff1a1a7a; background-image: url("./images/room_error.svg"); height: '+topLine+'px');
				}
			if ( bottomLineCorrect )
				{
					this.$('.bottom_room_setup_bar').attr('style', 'background-color: #1aff2382; background-image: url("./images/room_correct.svg"); height: '+bottomLine+'px');
				}
			else
				{
					this.$('.bottom_room_setup_bar').attr('style', 'background-color: #ff1a1a7a; background-image: url("./images/room_error.svg"); height: '+bottomLine+'px');
				}
		}
	
	finishMediaPipeCalculation = () =>
		{
			this.$('.top_room_setup_bar').addClass('d-none');
			this.$('.bottom_room_setup_bar').addClass('d-none');
			if ( window.clearTryAgain ) { window.clearTryAgain(); }
			let mainthis = this;
			if ( window.roomSetupNextStep ) { window.roomSetupNextStep(); }
			setTimeout(function() {
					window.mediaPipeCalculationFinish();
					window.showHideRoomSetup(true);
			}, 2000);
			
			let addObject = {"sessionId": this.currentUserData.sessionData.id, "event": "status", "eventType": "passCameraSetup", "userId": this.currentUserData.id, "details": JSON.stringify({"msg": "User passed Camera Setup"}), "timestamp": this.Util.getCurrentTimestamp()};
			this.sessionDataStore.addSessionData(addObject);
		}
		
	showMediaInterval = (intervalText) =>
		{
			if ( !window['alreadyClickedOnSkip'] )
				{
					this.$('#partBigCounter').removeClass('d-none');
					this.$('#partCounterNum').text(intervalText);
				}
			else
				{
					this.$('#partBigCounter').addClass('d-none');
				}
			
			let mainthis = this;
			
			if ( intervalText == 0 )
				{
					setTimeout(function() {
						mainthis.$('#partBigCounter').addClass('d-none');
					}, 1000);
				}
		}
	
	tiltCameraMessage = (innerText) =>
		{
			if ( window.callTiltMessage ) { window.callTiltMessage(innerText); }
		}
	
	addUpdateFlutterFunction = () =>
		{
			if ( !window['updateFlutterCanvas'] )
				{
					if ( ( !this.guestUser || this.hostVirtual ) && !this.onDemand )
						{
							window['updateFlutterCanvas'] = (userId) => {
								var waitingFlutter = false;
								
								if ( window['userWhiteboard'][userId] )
									{
										var flutterCanvas = document.querySelector('flt-glass-pane').shadowRoot.querySelector('canvas');
										
										if ( flutterCanvas )
											{
												var diffFlutter = window['autoSizeFltS'] ? window['autoSizeFltS'] : parseInt(flutterCanvas.style.width) / flutterCanvas.width;
												
												if ( !window['autoSizeFlt'] )
													{
														flutterCanvas.width = window.innerWidth/diffFlutter;
														flutterCanvas.height = window.innerHeight/diffFlutter;
														
														flutterCanvas.style.width = window.innerWidth+'px';
														flutterCanvas.style.height = window.innerHeight+'px';
													}
												
												waitingFlutter = true;
												
												setTimeout(() => {
													if ( window['userWhiteboard'][userId] )
														{
															var flutterCanvasX = 0;
															var flutterCanvasY = 0;
															
															var canvasDrawWidth = flutterCanvas.width*diffFlutter;
															var canvasDrawHeight = flutterCanvas.height*diffFlutter;
															
															if ( flutterCanvas.width < 1280 || window.innerWidth < 1280 ) { canvasDrawWidth = 1280; }
															if ( flutterCanvas.height < 720 || window.innerHeight < 720 ) { canvasDrawHeight = 720; }
															
															var drawContext = window['userWhiteboard'][userId].ctx;
															drawContext.clearRect(0, 0, 1280, 720);
															drawContext.drawImage(flutterCanvas, 0, 0, flutterCanvas.width, flutterCanvas.height, flutterCanvasX, flutterCanvasY, canvasDrawWidth, canvasDrawHeight);
															
															if ( window['poseSegmentationMask'] && window['userWhiteboard'][userId].hostVirtual )
																{
																	drawContext.save();
																	drawContext.globalCompositeOperation = 'destination-out';
																	drawContext.drawImage(window['poseSegmentationMask'], 0, 0, this.canvas.width, this.canvas.height);
																	drawContext.globalCompositeOperation = 'source-over';
																	drawContext.restore();
																}
																
															if ( this.showMediaPipePoints && this.useMediaPipe && window['poseDots'] && window.currentVirtualDraw == this.currentUserData.id )
																{
																	this.drawMediaPipeDots();
																}
																
															window.pendingVirtualDraw = false;
															var nextUser = window.currentVirtualDraw ? window.allUsersList.indexOf(window.currentVirtualDraw) + 1 : 0;
															if ( nextUser == window.allUsersList.length ) { nextUser = 0; }
															window.currentVirtualDraw = window.allUsersList[nextUser];
														}
												}, 1);
											}
									}
								
								if ( !waitingFlutter )
									{
										window.pendingVirtualDraw = false;
										var nextUser = window.currentVirtualDraw ? window.allUsersList.indexOf(window.currentVirtualDraw) + 1 : 0;
										if ( nextUser == window.allUsersList.length ) { nextUser = 0; }
										window.currentVirtualDraw = window.allUsersList[nextUser];
									}
							}
						}
					else
						{
							window['updateFlutterCanvas'] = (userId) => {
								if ( window['userCameraOff'] && userId == this.currentUserData.id ) { return; }

								if ( window['userWhiteboard'][userId] )
									{
										var flutterCanvas = document.querySelector('flt-glass-pane').shadowRoot.querySelector('canvas');
										
										if ( flutterCanvas )
											{
												var drawContext = window['userWhiteboard'][userId].ctx;
												
												var diffFlutter = window['autoSizeFltS'] ? window['autoSizeFltS'] : parseInt(flutterCanvas.style.width) / flutterCanvas.width;
												
												if ( !window['autoSizeFlt'] )
													{
														flutterCanvas.width = window.innerWidth/diffFlutter;
														flutterCanvas.height = window.innerHeight/diffFlutter;
														
														flutterCanvas.style.width = window.innerWidth+'px';
														flutterCanvas.style.height = window.innerHeight+'px';
													}
												
												var flutterCanvasX = 0;
												var flutterCanvasY = 0;
												
												var canvasDrawWidth = flutterCanvas.width*diffFlutter;
												var canvasDrawHeight = flutterCanvas.height*diffFlutter;
												
												if ( flutterCanvas.width < 1280 || window.innerWidth < 1280 ) { canvasDrawWidth = 1280; }
												if ( flutterCanvas.height < 720 || window.innerHeight < 720 ) { canvasDrawHeight = 720; }
												
												drawContext.clearRect(0, 0, 1280, 720);
												drawContext.drawImage(flutterCanvas, 0, 0, flutterCanvas.width, flutterCanvas.height, flutterCanvasX, flutterCanvasY, canvasDrawWidth, canvasDrawHeight);
												
												if ( window['poseSegmentationMask'] && !window['userWhiteboard'][userId].hostVirtualOnMember )
													{
														drawContext.save();
														drawContext.globalCompositeOperation = 'destination-out';
														drawContext.drawImage(window['poseSegmentationMask'], 0, 0, this.canvas.width, this.canvas.height);
														drawContext.globalCompositeOperation = 'source-over';
														drawContext.restore();
													}
													
												if ( this.showMediaPipePoints && this.useMediaPipe && window['poseDots'] )
													{
														this.drawMediaPipeDots();
													}
											}
									}
							}
						}
				}
		}
}

export default whiteboard;